import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Chip,
  CircularProgress,
  Tooltip,
  LinearProgress,
  Collapse,
  Card,
  CardContent,
  CardActionArea,
  Avatar,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  Select,
  FormControl,
  Badge,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
  Skeleton,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChatIcon from '@mui/icons-material/Chat';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SpeedIcon from '@mui/icons-material/Speed';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import BarChartIcon from '@mui/icons-material/BarChart';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import GridViewIcon from '@mui/icons-material/GridView';
// Novos ícones
import GroupsIcon from '@mui/icons-material/Groups';
import RouterIcon from '@mui/icons-material/Router';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TelegramIcon from '@mui/icons-material/Telegram';
import MessageIcon from '@mui/icons-material/Message';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import VisibilityIcon from '@mui/icons-material/Visibility';

import Base from '../../components/layout-base/base';
import CustomizedSnackbars from '../../components/material-snackbars';
import { AbilityContext } from '../../config/ability-context';
import * as AgentWorkspaceService from '../../services/agentworkspace.service';
import { PapiroConsole } from '../../utils/papiroConsole';
import Api from '../../services/api';
import Api2Talk from '../../services/api2talk';
import VoipDialConfirm from '../../components/voip/voip-dial-confirm';
import { useAgentWorkspaceHubContext } from '../../contexts/AgentWorkspaceHubContext';
import * as calledsActions from '../../redux/actions/calleds';

// Componentes reutilizados
import TreatCalledModal from '../called-list/components/treat-called-modal';
import RequesterHistoryDetailsModal from '../called-accompaniment/components/requester-history-details-modal';
import OmnichannelModal from './components/omnichannel-modal';
import HistoryIcon from '@mui/icons-material/History';
import BreakReasonStartDialog from 'src/components/break-reason/break-reason-start-dialog';

import LoginIcon from '@mui/icons-material/Login';

const styles = (theme) => ({
  // Layout principal - 2 colunas
  mainContainer: {
    display: 'flex',
    gap: '20px',
    padding: '20px',
    minHeight: 'calc(100vh - 120px)',
    background: '#f8fafc',
    // Responsividade
    [theme.breakpoints.down('lg')]: {
      gap: '16px',
      padding: '16px',
    },
    [theme.breakpoints.down('md')]: {
      gap: '12px',
      padding: '12px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '8px',
      padding: '8px',
    },
  },

  // Sidebar esquerda
  sidebar: {
    width: '200px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    // Responsividade
    [theme.breakpoints.down('lg')]: {
      width: '180px',
    },
    [theme.breakpoints.down('md')]: {
      width: '60px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  // Sidebar compacta em tablet
  sidebarCompact: {
    [theme.breakpoints.down('md')]: {
      '& $sidebarValue': {
        fontSize: '20px',
      },
      '& $sidebarLabel': {
        display: 'none',
      },
    },
  },
  sidebarCard: {
    padding: '20px',
    borderRadius: '16px',
    background: '#fff',
    border: '1px solid #e5e7eb',
    transition: 'all 0.2s',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    [theme.breakpoints.down('lg')]: {
      padding: '16px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '12px',
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  sidebarCardClickable: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    },
  },
  sidebarCardActiveChat: {
    borderColor: '#3b82f6',
    background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)',
  },
  sidebarCardActiveCalled: {
    borderColor: '#8b5cf6',
    background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
    boxShadow: '0 4px 12px rgba(139, 92, 246, 0.2)',
  },
  sidebarCardInfo: {
    cursor: 'default',
    '&:hover': {
      transform: 'none',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    },
  },
  sidebarValue: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: 1,
    marginBottom: '4px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '28px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      marginBottom: '0',
    },
  },
  sidebarLabel: {
    fontSize: '12px',
    fontWeight: 500,
    color: '#6b7280',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  sidebarDivider: {
    margin: '8px 0',
    borderColor: '#e5e7eb',
  },
  sidebarAction: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 16px',
    borderRadius: '10px',
    background: '#fff',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      background: '#f8fafc',
      borderColor: '#d1d5db',
    },
  },
  sidebarActionIcon: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  // Painel Recentes (direita)
  recentsPanel: {
    width: '280px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    transition: 'width 0.3s ease',
    overflow: 'hidden',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    // Responsividade
    [theme.breakpoints.down('lg')]: {
      width: '240px',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  recentsPanelCollapsed: {
    width: '48px',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  recentsPanelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
    borderRadius: '12px 12px 0 0',
    borderBottom: '1px solid #d1fae5',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #dcfce7 0%, #d1fae5 100%)',
    },
  },
  recentsPanelHeaderCollapsed: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '12px 8px',
    gap: '8px',
    borderRadius: '12px',
    borderBottom: 'none',
  },
  recentsPanelTitle: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#166534',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    letterSpacing: '0.3px',
  },
  recentsPanelTitleCollapsed: {
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
    transform: 'rotate(180deg)',
    fontSize: '12px',
    marginTop: '8px',
    color: '#166534',
  },
  recentsPanelContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 240px)',
    padding: '12px',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f5f9',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#cbd5e1',
      borderRadius: '4px',
    },
  },
  recentItem: {
    padding: '12px',
    background: '#fff',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#3b82f6',
      boxShadow: '0 2px 8px rgba(59,130,246,0.12)',
    },
  },
  recentItemNew: {
    animation: '$recentItemSlideIn 0.9s ease-out',
    borderColor: '#22c55e',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #fff 100%)',
    boxShadow: '0 0 0 2px rgba(34,197,94,0.3)',
  },
  '@keyframes recentItemSlideIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-30px) scale(0.95)',
      boxShadow: '0 -4px 12px rgba(34,197,94,0.4)',
    },
    '60%': {
      opacity: 1,
      transform: 'translateY(5px) scale(1.02)',
      boxShadow: '0 4px 16px rgba(34,197,94,0.3)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
      boxShadow: '0 0 0 2px rgba(34,197,94,0.3)',
    },
  },
  recentItemHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '6px',
  },
  recentItemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#374151',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  recentItemTimer: {
    fontSize: '10px',
    fontWeight: 500,
    padding: '2px 6px',
    borderRadius: '4px',
    background: '#f1f5f9',
    color: '#64748b',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  recentItemTimerExpiring: {
    background: '#fef3c7',
    color: '#d97706',
  },
  recentItemSubtitle: {
    fontSize: '11px',
    color: '#6b7280',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  recentItemType: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '10px',
    fontWeight: 500,
    padding: '2px 6px',
    borderRadius: '4px',
    marginRight: '6px',
  },
  recentItemTypeChat: {
    background: '#dbeafe',
    color: '#2563eb',
  },
  recentItemTypeCalled: {
    background: '#f3e8ff',
    color: '#7c3aed',
  },
  recentsPanelEmpty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    height: '100%',
    padding: '32px 16px',
    textAlign: 'center',
    color: '#9ca3af',
    background: 'transparent',
    borderRadius: '0',
    border: 'none',
  },

  // Area principal
  mainArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: 0,
    // Responsividade
    [theme.breakpoints.down('sm')]: {
      gap: '12px',
    },
  },

  // Header bar
  headerBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    flexWrap: 'wrap',
    gap: '12px',
    // Responsividade
    [theme.breakpoints.down('md')]: {
      padding: '10px 16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      borderRadius: '8px',
    },
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  userAvatar: {
    width: '40px',
    height: '40px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    fontSize: '16px',
    fontWeight: 600,
  },
  userName: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#1a1a2e',
  },
  statusSelect: {
    minWidth: '140px',
    '& .MuiSelect-select': {
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e5e7eb',
    },
  },
  statusDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
  },
  headerCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  alertBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '4px 8px',
      fontSize: '11px',
    },
  },
  alertCritical: {
    background: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
  },
  alertWarning: {
    background: '#fffbeb',
    color: '#d97706',
    border: '1px solid #fde68a',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
    },
  },
  // Barra de navegação mobile
  mobileNavBar: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      padding: '8px 12px',
      background: '#fff',
      borderRadius: '12px',
      border: '1px solid #e5e7eb',
      marginBottom: '8px',
    },
  },
  mobileNavButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '8px 16px',
    borderRadius: '8px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      background: '#f3f4f6',
    },
  },
  mobileNavButtonActive: {
    background: '#eff6ff',
    color: '#3b82f6',
  },
  mobileNavLabel: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#6b7280',
  },
  headerIconButton: {
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    padding: '8px',
    '&:hover': {
      background: '#f8fafc',
      borderColor: '#d1d5db',
    },
  },

  // Barra de filtros
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    gap: '12px',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      padding: '8px 12px',
    },
  },
  filterTabs: {
    display: 'flex',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
      flexWrap: 'wrap',
    },
  },
  filterTab: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    background: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    color: '#6b7280',
    cursor: 'pointer',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '&:hover': {
      borderColor: '#d1d5db',
      background: '#f8fafc',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '6px 10px',
      fontSize: '11px',
      gap: '4px',
    },
  },
  filterTabActive: {
    background: '#3b82f6',
    borderColor: '#3b82f6',
    color: '#fff',
    '&:hover': {
      background: '#2563eb',
      borderColor: '#2563eb',
    },
  },
  filterTabCount: {
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      padding: '1px 6px',
      fontSize: '10px',
    },
  },
  filterRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
      width: '100%',
      marginTop: '8px',
      flexShrink: 1,
    },
  },
  searchField: {
    minWidth: '180px',
    [theme.breakpoints.down('lg')]: {
      minWidth: '160px',
    },
    [theme.breakpoints.down('md')]: {
      minWidth: '140px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '0',
      flex: 1,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      background: '#f8fafc',
      '& fieldset': {
        borderColor: '#e5e7eb',
      },
      '&:hover fieldset': {
        borderColor: '#d1d5db',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 14px',
      fontSize: '13px',
    },
  },
  filterButton: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    background: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    color: '#6b7280',
    textTransform: 'none',
    '&:hover': {
      background: '#f8fafc',
      borderColor: '#d1d5db',
    },
  },

  // Layout toggle
  layoutToggle: {
    display: 'flex',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  layoutToggleButton: {
    padding: '6px 12px',
    border: 'none',
    background: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    '&:hover': {
      background: '#f8fafc',
    },
  },
  layoutToggleActive: {
    background: 'var(--mexx-green-primary, #8BC34A) !important',
    color: '#fff !important',
    '& svg': {
      color: '#fff !important',
    },
    '&:hover': {
      background: 'var(--mexx-green-dark, #689F38) !important',
    },
  },

  // Grupos de urgencia
  urgencyGroup: {
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    overflow: 'hidden',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '8px',
      marginBottom: '8px',
    },
  },
  urgencyHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#fafafa',
    },
  },
  urgencyHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  urgencyIcon: {
    fontSize: '20px',
  },
  urgencyTitle: {
    fontSize: '14px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  urgencyCount: {
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#fff',
  },
  urgencyHeaderCritical: {
    borderBottom: '3px solid #ef4444',
  },
  urgencyHeaderWarning: {
    borderBottom: '3px solid #f59e0b',
  },
  urgencyHeaderNormal: {
    borderBottom: '3px solid #22c55e',
  },
  urgencyHeaderWaiting: {
    borderBottom: '3px solid #94a3b8',
    background: '#f8fafc',
  },

  // Cards de itens
  itemsList: {
    padding: '8px',
    [theme.breakpoints.down('sm')]: {
      padding: '4px',
    },
  },
  itemsGrid: {
    padding: '8px',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '8px',
      padding: '4px',
    },
  },
  workItemCard: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '14px 16px',
    borderRadius: '10px',
    border: '1px solid #f3f4f6',
    marginBottom: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: '#fff',
    '&:hover': {
      borderColor: '#e5e7eb',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      '& $openButton': {
        opacity: 1,
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 12px',
      marginBottom: '6px',
    },
  },
  // Animação para novos itens via SignalR
  workItemCardNew: {
    animation: '$newItemSlideIn 0.4s ease-out',
    borderColor: '#22c55e',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #fff 100%)',
    boxShadow: '0 0 0 2px rgba(34,197,94,0.2)',
  },
  '@keyframes newItemSlideIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-20px)',
      boxShadow: '0 0 0 4px rgba(34,197,94,0.4)',
    },
    '50%': {
      boxShadow: '0 0 0 8px rgba(34,197,94,0.2)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
      boxShadow: '0 0 0 2px rgba(34,197,94,0.2)',
    },
  },
  workItemCardGrid: {
    display: 'flex',
    flexDirection: 'column',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #f3f4f6',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: '#fff',
    height: '100%',
    position: 'relative',
    '&:hover': {
      borderColor: '#e5e7eb',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    },
  },
  gridCardAccent: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    borderRadius: '10px 0 0 10px',
  },
  gridCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '10px',
  },
  gridCardTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#1a1a2e',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    marginBottom: '8px',
    minHeight: '36px',
  },
  gridCardMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '10px',
    flex: 1,
  },
  gridCardMetaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '11px',
    color: '#6b7280',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& svg': {
      fontSize: '12px',
      color: '#9ca3af',
      flexShrink: 0,
    },
  },
  gridCardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '10px',
    borderTop: '1px solid #f3f4f6',
    marginTop: 'auto',
  },
  gridSlaChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 700,
  },
  itemAccent: {
    width: '4px',
    borderRadius: '2px',
    marginRight: '14px',
    flexShrink: 0,
  },
  itemContent: {
    flex: 1,
    minWidth: 0,
  },
  itemHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  itemTypeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  itemTypeCalled: {
    background: '#eff6ff',
    color: '#2563eb',
  },
  itemTypeChat: {
    background: '#f0fdf4',
    color: '#16a34a',
  },
  itemTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '4px',
  },
  itemTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a1a2e',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  itemPreview: {
    fontSize: '13px',
    color: '#6b7280',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: '8px',
    fontStyle: 'italic',
  },
  itemMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  itemMetaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    color: '#6b7280',
    '& svg': {
      fontSize: '14px',
      color: '#9ca3af',
    },
  },
  itemRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '8px',
    marginLeft: '16px',
    flexShrink: 0,
  },
  slaSection: {
    textAlign: 'right',
  },
  slaTime: {
    fontSize: '14px',
    fontWeight: 700,
    marginBottom: '4px',
  },
  slaBar: {
    width: '100px',
    height: '6px',
    borderRadius: '3px',
    background: '#f3f4f6',
    overflow: 'hidden',
  },
  slaBarFill: {
    height: '100%',
    borderRadius: '3px',
    transition: 'width 0.3s',
  },
  waitingTime: {
    fontSize: '11px',
    color: '#9ca3af',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  openButton: {
    opacity: 0,
    transition: 'opacity 0.2s',
    padding: '6px 12px',
    borderRadius: '6px',
    background: 'var(--mexx-green-primary, #8BC34A)',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      background: 'var(--mexx-green-dark, #689F38)',
    },
  },

  // Cores
  colorCritical: { color: '#ef4444' },
  colorWarning: { color: '#f59e0b' },
  colorNormal: { color: '#22c55e' },
  colorWaiting: { color: '#64748b' },
  bgCritical: { background: '#ef4444' },
  bgWarning: { background: '#f59e0b' },
  bgNormal: { background: '#22c55e' },
  bgWaiting: { background: '#94a3b8' },

  // Empty e Loading
  emptyState: {
    padding: '48px 20px',
    textAlign: 'center',
  },
  emptyIcon: {
    width: '56px',
    height: '56px',
    borderRadius: '14px',
    background: '#f0fdf4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 12px',
    '& svg': {
      fontSize: '28px',
      color: '#22c55e',
    },
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    gap: '16px',
  },

  // Dialog
  dialogContent: {
    minWidth: '480px',
    maxHeight: '60vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '3px',
      '&:hover': {
        background: '#a1a1a1',
      },
    },
  },
  preferenceItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #f3f4f6',
  },
  preferenceLabel: {
    fontSize: '14px',
    color: '#1a1a2e',
  },
  preferenceDescription: {
    fontSize: '12px',
    color: '#6b7280',
    marginTop: '2px',
  },
  preferenceSection: {
    marginBottom: '20px',
  },
  preferenceSectionTitle: {
    fontSize: '12px',
    fontWeight: 700,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '12px',
    paddingBottom: '8px',
    borderBottom: '2px solid #e5e7eb',
  },

  // Stats Modal
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    marginBottom: '20px',
  },
  statCard: {
    padding: '20px',
    borderRadius: '12px',
    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    textAlign: 'center',
  },
  statValue: {
    fontSize: '32px',
    fontWeight: 700,
    marginBottom: '4px',
  },
  statLabel: {
    fontSize: '13px',
    color: '#6b7280',
  },

  // Filter Menu
  filterMenuContent: {
    padding: '0',
    minWidth: '420px',
    maxWidth: '520px',
  },
  filterMenuHeader: {
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    borderBottom: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  filterMenuHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '15px',
    fontWeight: 700,
    color: '#1f2937',
  },
  filterMenuHeaderIcon: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    background: 'var(--mexx-green-primary, #8BC34A)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(139, 195, 74, 0.3)',
  },
  filterMenuBadge: {
    background: '#dbeafe',
    color: '#1d4ed8',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 700,
  },
  filterMenuBody: {
    padding: '16px 20px',
    maxHeight: '400px',
    overflowY: 'auto',
  },
  filterMenuSection: {
    marginBottom: '16px',
    paddingBottom: '16px',
    borderBottom: '1px solid rgba(139, 195, 74, 0.4)',
    '&:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottom: 'none',
    },
  },
  filterMenuSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
  },
  filterMenuLabel: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  filterMenuChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
  },
  filterChip: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
  },
  filterChipActive: {
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important',
    color: '#fff !important',
    boxShadow: '0 2px 4px rgba(34, 197, 94, 0.3) !important',
  },
  filterMenuFooter: {
    padding: '12px 20px',
    borderTop: '1px solid #e5e7eb',
    background: '#fafafa',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  filterMenuDivider: {
    margin: '16px 0',
    borderColor: '#f1f5f9',
  },

  // Waiting Customer Badge
  waitingCustomerBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    borderRadius: '4px',
    background: '#fef3c7',
    color: '#92400e',
    fontSize: '10px',
    fontWeight: 600,
    marginLeft: '8px',
  },

  // Priority Badge
  priorityBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 600,
    marginLeft: '8px',
  },

  // Loading more indicator
  loadingMore: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },

  // Scrollable container
  scrollableContainer: {
    flex: 1,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '4px',
      '&:hover': {
        background: '#a1a1a1',
      },
    },
  },

  // Active filters indicator
  activeFiltersBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    background: '#eff6ff',
    borderRadius: '8px',
    marginBottom: '12px',
  },
  activeFiltersText: {
    fontSize: '13px',
    color: '#1d4ed8',
    fontWeight: 500,
  },
});

class AgentWorkspace extends Component {
  constructor(props) {
    super(props);

    // Carregar preferência de layout do localStorage
    const savedLayout = localStorage.getItem('agentWorkspace_layoutMode');

    this.state = {
      loading: true,
      // VOIP — atalho de ligação (reuso do softphone global: window.__mexxVoip + evento voip:dial).
      voipState: (typeof window !== 'undefined' && window.__mexxVoip) || { enabled: false, hasRamal: false, ramal: null },
      dialConfirm: { open: false, number: '', providerName: '', calledId: null, contact: null },
      dialLoadingItemId: null,
      loadingHelper: false,
      refreshing: false,
      loadingMore: false,
      queue: [],
      queueCounts: { totalcount: 0, criticalcount: 0, warningcount: 0, normalcount: 0, waitingcount: 0 },
      hasMore: true,
      offset: 0,
      limit: 10,
      // Paginação separada por tipo (usado no modo "Todos")
      calledItems: [],
      chatItems: [],
      calledHasMore: true,
      chatHasMore: true,
      loadingMoreCalled: false,
      loadingMoreChat: false,
      metrics: null,
      preferences: null,
      filterOptions: null,
      agentStatus: 1, // 1=Disponível, 2=Ocupado, 3=Pausado
      activeFilter: 'all', // all, chat, called
      searchTerm: '',
      searchDebounceTimer: null,
      layoutMode: savedLayout || 'list',
      expandedGroups: {
        // Chamados
        called_critical: true,
        called_warning: true,
        called_normal: true,
        called_waiting: false,
        // Chats
        chat_critical: true,
        chat_warning: true,
        chat_normal: true,
        chat_waiting: false,
      },
      // Filtros avançados
      advancedFilters: {
        priorityId: null,
        channelName: null,
        messageProviderName: null,
        urgencyGroup: null,
        categoryName: null,
        statusName: null,
      },
      // Configurações temporárias (para o dialog)
      tempPreferences: null,
      savingPreferences: false,
      // UI states
      openNotification: false,
      notificationVariant: 'info',
      notificationMessage: '',
      settingsOpen: false,
      statsOpen: false,
      notificationsAnchor: null,
      filterMenuAnchor: null,
      // Modal de Detalhes (RequesterHistoryDetailsModal)
      detailsModalOpen: false,
      selectedItemForDetails: null,
      // Modal de Tratamento Rápido (TreatCalledModal)
      treatCalledModalOpen: false,
      calledToTreat: null,
      // Modal de Omnichannel (OmnichannelModal)
      omnichannelModalOpen: false,
      selectedChatItem: null,
      // Painel de Recentes
      recentItems: [],
      recentsPanelOpen: localStorage.getItem('agentWorkspace_recentsPanelOpen') !== 'false',
      // Modal de Iniciar uma Pausa (BreakReasonStartDialog)
      breakReasonStartOpen: false,
      selectedNewStatusForBreak: null,
    };

    this.listContainerRef = React.createRef();
    this.recentsTimerRef = null;
  }

  componentDidMount() {
    // Registrar função global para remover chamado da lista (usado pelo TreatCalledModal)
    window.__removeCalledFromList = this.removeCalledFromList;

    // Registrar callbacks do SignalR Context para receber atualizações em tempo real
    this.registerSignalRCallbacks();

    // VOIP — acompanha o estado do softphone global (habilitado + ramal do agente) pra mostrar/ocultar o atalho.
    window.addEventListener('voip:state', this.onVoipState);
    if (typeof window !== 'undefined' && window.__mexxVoip) this.setState({ voipState: window.__mexxVoip });

    this.loadInitialData();
  }

  componentWillUnmount() {
    window.removeEventListener('voip:state', this.onVoipState);
    if (this.state.searchDebounceTimer) clearTimeout(this.state.searchDebounceTimer);

    // Cleanup do timer de recentes
    if (this.recentsTimerRef) {
      clearInterval(this.recentsTimerRef);
      this.recentsTimerRef = null;
    }

    // Cleanup dos callbacks do SignalR
    if (this.unsubscribeNewItem) this.unsubscribeNewItem();
    if (this.unsubscribeItemRemoved) this.unsubscribeItemRemoved();
    if (this.unsubscribeItemUpdated) this.unsubscribeItemUpdated();
    if (this.unsubscribeItemClosed) this.unsubscribeItemClosed();
  }

  // Registrar callbacks para receber eventos do SignalR via Context
  registerSignalRCallbacks = () => {
    const { agentWorkspaceHub } = this.props;
    if (!agentWorkspaceHub) return;

    // Callback para novo item - adiciona no topo da lista local independente da paginação
    if (agentWorkspaceHub.registerNewItemCallback) {
      this.unsubscribeNewItem = agentWorkspaceHub.registerNewItemCallback(this.handleSignalRNewItem);
    }

    // Callback para item removido
    if (agentWorkspaceHub.registerItemRemovedCallback) {
      this.unsubscribeItemRemoved = agentWorkspaceHub.registerItemRemovedCallback(this.handleSignalRItemRemoved);
    }

    // Callback para item atualizado
    if (agentWorkspaceHub.registerItemUpdatedCallback) {
      this.unsubscribeItemUpdated = agentWorkspaceHub.registerItemUpdatedCallback(this.handleSignalRItemUpdated);
    }

    // Callback para item fechado de outra tela
    if (agentWorkspaceHub.registerItemClosedCallback) {
      this.unsubscribeItemClosed = agentWorkspaceHub.registerItemClosedCallback(this.handleSignalRItemClosed);
    }
  }

  // Handler para novo item via SignalR - adiciona no topo IMEDIATAMENTE
  handleSignalRNewItem = (item) => {
    if (!item) return;

    const { activeFilter, loading } = this.state;
    if (loading) return; // Evitar conflito durante carregamento inicial

    PapiroConsole.log("AgentWorkspace: SignalR NewItem callback", item.itemid, item.itemtype);

    // Verificar se o item passa no filtro ativo
    const isChat = item.itemtype === 1;
    const isCalled = item.itemtype === 0;
    const passesFilter = activeFilter === 'all' ||
      (activeFilter === 'chat' && isChat) ||
      (activeFilter === 'called' && isCalled);

    // Marcar item como novo para animação
    const newItem = {
      ...item,
      _isNew: true,
      _addedAt: Date.now(),
    };

    this.setState(prevState => {
      const newState = {};

      // Adicionar à queue principal se passa no filtro
      if (passesFilter) {
        const existsInQueue = prevState.queue.some(q =>
          q.itemid === item.itemid && q.itemtype === item.itemtype
        );

        if (!existsInQueue) {
          newState.queue = [newItem, ...prevState.queue];
        } else {
          // Atualizar item existente
          newState.queue = prevState.queue.map(q =>
            (q.itemid === item.itemid && q.itemtype === item.itemtype) ? newItem : q
          );
        }
      }

      // Atualizar listas separadas (para modo "Todos")
      if (isCalled) {
        const existsInCalled = prevState.calledItems.some(q =>
          q.itemid === item.itemid && q.itemtype === item.itemtype
        );
        if (!existsInCalled) {
          newState.calledItems = [newItem, ...prevState.calledItems];
        }
      } else if (isChat) {
        const existsInChat = prevState.chatItems.some(q =>
          q.itemid === item.itemid && q.itemtype === item.itemtype
        );
        if (!existsInChat) {
          newState.chatItems = [newItem, ...prevState.chatItems];
        }
      }

      // Atualizar contadores da queue
      const urgencyGroup = this.normalizeUrgencyGroup(item.urgencygroup);
      const countKey = `${urgencyGroup}count`;
      newState.queueCounts = {
        ...prevState.queueCounts,
        totalcount: prevState.queueCounts.totalcount + 1,
        [countKey]: (prevState.queueCounts[countKey] || 0) + 1,
      };

      // Atualizar métricas (contadores da sidebar) localmente
      if (prevState.metrics) {
        newState.metrics = {
          ...prevState.metrics,
          totalitems: (prevState.metrics.totalitems || 0) + 1,
          activechats: isChat ? (prevState.metrics.activechats || 0) + 1 : prevState.metrics.activechats,
          opencalleds: isCalled ? (prevState.metrics.opencalleds || 0) + 1 : prevState.metrics.opencalleds,
          criticalcount: urgencyGroup === 'critical' ? (prevState.metrics.criticalcount || 0) + 1 : prevState.metrics.criticalcount,
          warningcount: urgencyGroup === 'warning' ? (prevState.metrics.warningcount || 0) + 1 : prevState.metrics.warningcount,
        };
      }

      // Adicionar ao painel de Recentes
      const recentItem = {
        ...item,
        _recentAddedAt: Date.now(),
        _isNew: true,
      };
      const maxItems = prevState.preferences?.recentsmaxitems || 10;
      newState.recentItems = [recentItem, ...prevState.recentItems].slice(0, maxItems);

      return newState;
    });

    // Iniciar/reiniciar timer de limpeza dos recentes
    this.startRecentsCleanupTimer();
  }

  // Handler para item removido via SignalR
  handleSignalRItemRemoved = (data, removedItem) => {
    if (!data || !data.itemid) return;

    PapiroConsole.log("AgentWorkspace: SignalR ItemRemoved callback", data.itemid, data.itemtype);

    this.setState(prevState => {
      // Encontrar item antes de remover para ajustar contadores
      const item = removedItem || prevState.queue.find(q =>
        q.itemid === data.itemid && q.itemtype === data.itemtype
      );

      const newState = {
        queue: prevState.queue.filter(q =>
          !(q.itemid === data.itemid && q.itemtype === data.itemtype)
        ),
        calledItems: prevState.calledItems.filter(q =>
          !(q.itemid === data.itemid && q.itemtype === data.itemtype)
        ),
        chatItems: prevState.chatItems.filter(q =>
          !(q.itemid === data.itemid && q.itemtype === data.itemtype)
        ),
      };

      // Atualizar contadores se encontrou o item
      if (item) {
        const urgencyGroup = this.normalizeUrgencyGroup(item.urgencygroup);
        const countKey = `${urgencyGroup}count`;
        const isChat = item.itemtype === 1;
        const isCalled = item.itemtype === 0;

        newState.queueCounts = {
          ...prevState.queueCounts,
          totalcount: Math.max(0, prevState.queueCounts.totalcount - 1),
          [countKey]: Math.max(0, (prevState.queueCounts[countKey] || 0) - 1),
        };

        // Atualizar métricas (contadores da sidebar) localmente
        if (prevState.metrics) {
          newState.metrics = {
            ...prevState.metrics,
            totalitems: Math.max(0, (prevState.metrics.totalitems || 0) - 1),
            activechats: isChat ? Math.max(0, (prevState.metrics.activechats || 0) - 1) : prevState.metrics.activechats,
            opencalleds: isCalled ? Math.max(0, (prevState.metrics.opencalleds || 0) - 1) : prevState.metrics.opencalleds,
            criticalcount: urgencyGroup === 'critical' ? Math.max(0, (prevState.metrics.criticalcount || 0) - 1) : prevState.metrics.criticalcount,
            warningcount: urgencyGroup === 'warning' ? Math.max(0, (prevState.metrics.warningcount || 0) - 1) : prevState.metrics.warningcount,
          };
        }
      }

      return newState;
    });
  }

  // Handler para item atualizado via SignalR
  handleSignalRItemUpdated = (item) => {
    if (!item) return;

    PapiroConsole.log("AgentWorkspace: SignalR ItemUpdated callback", item.itemid, item.itemtype);

    this.setState(prevState => ({
      queue: prevState.queue.map(q =>
        (q.itemid === item.itemid && q.itemtype === item.itemtype) ? item : q
      ),
      calledItems: prevState.calledItems.map(q =>
        (q.itemid === item.itemid && q.itemtype === item.itemtype) ? item : q
      ),
      chatItems: prevState.chatItems.map(q =>
        (q.itemid === item.itemid && q.itemtype === item.itemtype) ? item : q
      ),
    }));
  }

  // Handler para item fechado de outra tela via SignalR
  handleSignalRItemClosed = (data, removedItem) => {
    if (!data || !data.itemId) return;

    // Mapear itemType do backend para itemtype do frontend
    const itemType = data.itemType === 'CHAT' ? 1 : 0;
    const itemId = data.itemId;

    PapiroConsole.log("AgentWorkspace: SignalR ItemClosed callback", itemId, data.itemType);

    this.setState(prevState => {
      // Encontrar item antes de remover para ajustar contadores
      const item = removedItem || prevState.queue.find(q =>
        q.itemid === itemId && q.itemtype === itemType
      );

      const newState = {
        queue: prevState.queue.filter(q =>
          !(q.itemid === itemId && q.itemtype === itemType)
        ),
        calledItems: prevState.calledItems.filter(q =>
          !(q.itemid === itemId && q.itemtype === itemType)
        ),
        chatItems: prevState.chatItems.filter(q =>
          !(q.itemid === itemId && q.itemtype === itemType)
        ),
      };

      // Atualizar contadores se encontrou o item
      if (item) {
        const urgencyGroup = this.normalizeUrgencyGroup(item.urgencygroup);
        const countKey = `${urgencyGroup}count`;
        const isChat = item.itemtype === 1;
        const isCalled = item.itemtype === 0;

        newState.queueCounts = {
          ...prevState.queueCounts,
          totalcount: Math.max(0, prevState.queueCounts.totalcount - 1),
          [countKey]: Math.max(0, (prevState.queueCounts[countKey] || 0) - 1),
        };

        // Atualizar métricas (contadores da sidebar) localmente
        if (prevState.metrics) {
          newState.metrics = {
            ...prevState.metrics,
            totalitems: Math.max(0, (prevState.metrics.totalitems || 0) - 1),
            activechats: isChat ? Math.max(0, (prevState.metrics.activechats || 0) - 1) : prevState.metrics.activechats,
            opencalleds: isCalled ? Math.max(0, (prevState.metrics.opencalleds || 0) - 1) : prevState.metrics.opencalleds,
            criticalcount: urgencyGroup === 'critical' ? Math.max(0, (prevState.metrics.criticalcount || 0) - 1) : prevState.metrics.criticalcount,
            warningcount: urgencyGroup === 'warning' ? Math.max(0, (prevState.metrics.warningcount || 0) - 1) : prevState.metrics.warningcount,
          };
        }
      }

      return newState;
    });

    // Se o item estava aberto em algum painel, fechar ou atualizar
    const { selectedItem, omniChannelModalOpen, calledDetailModalOpen } = this.state;
    if (selectedItem && selectedItem.itemid === itemId &&
        ((itemType === 1 && omniChannelModalOpen) || (itemType === 0 && calledDetailModalOpen))) {
      // Fechar o modal e mostrar mensagem
      this.setState({
        omniChannelModalOpen: false,
        calledDetailModalOpen: false,
        selectedItem: null,
      });
    }
  }


  // Recalcular contadores após mudanças na fila
  recalculateQueueCounts = (queue) => {
    const counts = {
      totalcount: queue.length,
      criticalcount: queue.filter(item => this.normalizeUrgencyGroup(item.urgencygroup) === 'critical').length,
      warningcount: queue.filter(item => this.normalizeUrgencyGroup(item.urgencygroup) === 'warning').length,
      normalcount: queue.filter(item => this.normalizeUrgencyGroup(item.urgencygroup) === 'normal').length,
      waitingcount: queue.filter(item => this.normalizeUrgencyGroup(item.urgencygroup) === 'waiting').length,
    };
    this.setState({ queueCounts: counts });
  }

  // ===== Painel de Recentes =====

  // Iniciar timer para limpar itens expirados do painel de recentes
  startRecentsCleanupTimer = () => {
    // Limpar timer anterior se existir
    if (this.recentsTimerRef) {
      clearInterval(this.recentsTimerRef);
    }

    // Criar novo timer que roda a cada segundo
    this.recentsTimerRef = setInterval(() => {
      this.cleanupExpiredRecents();
    }, 1000);
  }

  // Limpar itens expirados do painel de recentes e flags _isNew da queue
  cleanupExpiredRecents = () => {
    const { recentItems, preferences, queue, calledItems, chatItems } = this.state;
    const expirationMs = (preferences?.recentstimeminutes || 5) * 60 * 1000;
    const newItemDurationMs = 3000; // 3 segundos para animação
    const now = Date.now();
    const stateUpdates = {};

    // Processar painel de recentes
    if (recentItems && recentItems.length > 0) {
      const filteredItems = recentItems
        .map(item => ({
          ...item,
          _isNew: (now - item._recentAddedAt) < newItemDurationMs,
        }))
        .filter(item => (now - item._recentAddedAt) < expirationMs);

      if (filteredItems.length !== recentItems.length ||
          recentItems.some((item, i) => filteredItems[i] && item._isNew !== filteredItems[i]._isNew)) {
        stateUpdates.recentItems = filteredItems;
      }

      // Parar timer se não houver mais itens recentes e nenhum item novo na queue
      if (filteredItems.length === 0) {
        const hasNewInQueue = queue.some(item => item._isNew && (now - item._addedAt) < newItemDurationMs);
        if (!hasNewInQueue && this.recentsTimerRef) {
          clearInterval(this.recentsTimerRef);
          this.recentsTimerRef = null;
        }
      }
    }

    // Limpar flags _isNew da queue principal após 3 segundos
    const cleanedQueue = queue.map(item => {
      if (item._isNew && item._addedAt && (now - item._addedAt) >= newItemDurationMs) {
        return { ...item, _isNew: false };
      }
      return item;
    });
    if (cleanedQueue.some((item, i) => item._isNew !== queue[i]._isNew)) {
      stateUpdates.queue = cleanedQueue;
    }

    // Limpar flags _isNew de calledItems
    const cleanedCalled = calledItems.map(item => {
      if (item._isNew && item._addedAt && (now - item._addedAt) >= newItemDurationMs) {
        return { ...item, _isNew: false };
      }
      return item;
    });
    if (cleanedCalled.some((item, i) => item._isNew !== calledItems[i]._isNew)) {
      stateUpdates.calledItems = cleanedCalled;
    }

    // Limpar flags _isNew de chatItems
    const cleanedChat = chatItems.map(item => {
      if (item._isNew && item._addedAt && (now - item._addedAt) >= newItemDurationMs) {
        return { ...item, _isNew: false };
      }
      return item;
    });
    if (cleanedChat.some((item, i) => item._isNew !== chatItems[i]._isNew)) {
      stateUpdates.chatItems = cleanedChat;
    }

    // Aplicar atualizações se houver
    if (Object.keys(stateUpdates).length > 0) {
      this.setState(stateUpdates);
    }
  }

  // Calcular tempo restante para expiração de um item recente
  getRecentItemTimeRemaining = (item) => {
    const { preferences } = this.state;
    const expirationMs = (preferences?.recentstimeminutes || 5) * 60 * 1000;
    const elapsed = Date.now() - item._recentAddedAt;
    const remaining = Math.max(0, expirationMs - elapsed);
    return Math.ceil(remaining / 1000); // em segundos
  }

  // Formatar tempo restante para exibição
  formatRecentTimeRemaining = (seconds) => {
    if (seconds <= 0) return '0s';
    if (seconds < 60) return `${seconds}s`;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
  }

  // Toggle do painel de recentes
  toggleRecentsPanel = () => {
    this.setState(prevState => {
      const newOpen = !prevState.recentsPanelOpen;
      localStorage.setItem('agentWorkspace_recentsPanelOpen', newOpen.toString());
      return { recentsPanelOpen: newOpen };
    });
  }

  // Handler para clique em item recente - abre o modal apropriado
  handleRecentItemClick = (item) => {
    if (item.itemtype === 1) {
      // Chat - abre modal omnichannel
      this.openOmnichannelModal(item);
    } else {
      // Chamado - abre modal de tratamento rápido
      this.openTreatCalledModal(item);
    }
  }

  // Helper para normalizar urgencyGroup (pode ser string ou number/enum)
  normalizeUrgencyGroup = (urgencyGroup) => {
    if (urgencyGroup == null) return 'normal';
    if (typeof urgencyGroup === 'number') {
      switch (urgencyGroup) {
        case 0: return 'critical';
        case 1: return 'warning';
        case 2: return 'normal';
        case 3: return 'waiting';
        default: return 'normal';
      }
    }
    if (typeof urgencyGroup === 'string') {
      return urgencyGroup.toLowerCase();
    }
    return 'normal';
  }

  // Helper para formatar tempo de forma inteligente
  formatSmartTime = (seconds) => {
    if (!seconds || seconds <= 0) return '0s';

    if (seconds < 60) {
      return `${Math.round(seconds)}s`;
    }
    if (seconds < 3600) {
      const mins = Math.floor(seconds / 60);
      return `${mins}min`;
    }
    if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
    }
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  }

  // Sincronizar queue com o contexto SignalR
  syncQueueWithContext = (queueItems) => {
    const { agentWorkspaceHub } = this.props;
    if (agentWorkspaceHub && agentWorkspaceHub.setQueue) {
      PapiroConsole.log("AgentWorkspace: Syncing queue with SignalR context", queueItems.length, "items");
      agentWorkspaceHub.setQueue(queueItems);
    }
  }

  async loadInitialData() {
    try {
      this.setState({ loading: true });

      const [metricsResult, prefsResult, statusResult, filtersResult] = await Promise.all([
        AgentWorkspaceService.getMetrics(),
        AgentWorkspaceService.getPreferences(),
        AgentWorkspaceService.getStatus(),
        AgentWorkspaceService.getQueueFilters(),
      ]);

      // NÃO setar loading: false aqui - será setado após loadQueue terminar
      const newState = {};

      if (metricsResult?.success && metricsResult.data) {
        newState.metrics = metricsResult.data;
      }
      if (prefsResult?.success && prefsResult.data) {
        newState.preferences = prefsResult.data;
        // Aplicar grupos expandidos das preferências (com chaves compostas para separar Chamados e Chats)
        if (prefsResult.data.defaultexpandedgroups) {
          const expanded = prefsResult.data.defaultexpandedgroups.split(',');
          newState.expandedGroups = {
            // Chamados
            called_critical: expanded.includes('critical'),
            called_warning: expanded.includes('warning'),
            called_normal: expanded.includes('normal'),
            called_waiting: expanded.includes('waiting'),
            // Chats
            chat_critical: expanded.includes('critical'),
            chat_warning: expanded.includes('warning'),
            chat_normal: expanded.includes('normal'),
            chat_waiting: expanded.includes('waiting'),
          };
        }
        // Aplicar itens por página das preferências
        if (prefsResult.data.itemsperpage) {
          newState.limit = prefsResult.data.itemsperpage;
        }
      }
      if (statusResult?.success && statusResult.data) {
        newState.agentStatus = statusResult.data.statusid || 1;
      }
      if (filtersResult?.success && filtersResult.data) {
        newState.filterOptions = filtersResult.data;
      }

      this.setState(newState);

      // Sincronizar com o contexto SignalR para que eventos atualizem o state compartilhado
      const { agentWorkspaceHub } = this.props;
      if (agentWorkspaceHub) {
        if (newState.preferences && agentWorkspaceHub.setPreferences) {
          agentWorkspaceHub.setPreferences(newState.preferences);
        }
        if (newState.metrics && agentWorkspaceHub.setMetrics) {
          agentWorkspaceHub.setMetrics(newState.metrics);
        }
      }

      // Aguardar loadQueue terminar antes de remover o loading
      await this.loadQueue(true);
      this.setState({ loading: false });
    } catch (err) {
      PapiroConsole.log('Error loading initial data', err);
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: 'Erro ao carregar dados',
      });
    }
  }

  async loadQueue(reset = false, filterOverride = null, advancedFiltersOverride = null) {
    const { activeFilter: stateFilter, searchTerm, advancedFilters: stateAdvancedFilters, limit, queue } = this.state;

    // Usar override se fornecido, senão usar o state
    const activeFilter = filterOverride !== null ? filterOverride : stateFilter;
    const advancedFilters = advancedFiltersOverride !== null ? advancedFiltersOverride : stateAdvancedFilters;

    try {
      const offset = reset ? 0 : queue.length;
      if (!reset) this.setState({ loadingMore: true });

      // Construir params de filtro removendo valores null/undefined
      const filterParams = {};
      if (advancedFilters.priorityId != null) filterParams.priorityId = advancedFilters.priorityId;
      if (advancedFilters.channelName) filterParams.channelName = advancedFilters.channelName;
      if (advancedFilters.messageProviderName) filterParams.messageProviderName = advancedFilters.messageProviderName;
      if (advancedFilters.urgencyGroup) filterParams.urgencyGroup = advancedFilters.urgencyGroup;
      if (advancedFilters.categoryName) filterParams.categoryName = advancedFilters.categoryName;
      if (advancedFilters.statusName) filterParams.statusName = advancedFilters.statusName;

      // Quando "Todos" está selecionado, fazer duas chamadas paralelas para garantir que ambos os tipos apareçam
      if (activeFilter === 'all' && reset) {
        const [calledResult, chatResult] = await Promise.all([
          AgentWorkspaceService.getQueue({ offset: 0, limit, searchTerm: searchTerm || undefined, itemType: 'called', ...filterParams }),
          AgentWorkspaceService.getQueue({ offset: 0, limit, searchTerm: searchTerm || undefined, itemType: 'chat', ...filterParams }),
        ]);

        const calledItems = calledResult?.success ? (calledResult.data?.items || []) : [];
        const chatItems = chatResult?.success ? (chatResult.data?.items || []) : [];
        const allItems = [...calledItems, ...chatItems];

        // Calcular contadores combinados
        const calledCounts = calledResult?.data || {};
        const chatCounts = chatResult?.data || {};

        this.setState({
          loadingMore: false,
          refreshing: false,
          queue: allItems,
          offset: allItems.length,
          hasMore: false, // No modo "Todos", usamos paginação por tipo
          // Itens separados por tipo para paginação independente
          calledItems: calledItems,
          chatItems: chatItems,
          calledHasMore: calledResult?.data?.hasmore || false,
          chatHasMore: chatResult?.data?.hasmore || false,
          queueCounts: {
            totalcount: (calledCounts.totalcount || 0) + (chatCounts.totalcount || 0),
            criticalcount: (calledCounts.criticalcount || 0) + (chatCounts.criticalcount || 0),
            warningcount: (calledCounts.warningcount || 0) + (chatCounts.warningcount || 0),
            normalcount: (calledCounts.normalcount || 0) + (chatCounts.normalcount || 0),
            waitingcount: (calledCounts.waitingcount || 0) + (chatCounts.waitingcount || 0),
          },
          // Guardar contadores separados para exibição nos blocos
          calledCounts: {
            total: calledCounts.totalcount || 0,
            critical: calledCounts.criticalcount || 0,
            warning: calledCounts.warningcount || 0,
            normal: calledCounts.normalcount || 0,
            waiting: calledCounts.waitingcount || 0,
          },
          chatCounts: {
            total: chatCounts.totalcount || 0,
            critical: chatCounts.criticalcount || 0,
            warning: chatCounts.warningcount || 0,
            normal: chatCounts.normalcount || 0,
            waiting: chatCounts.waitingcount || 0,
          },
        });

        // Sincronizar queue com o contexto SignalR
        this.syncQueueWithContext(allItems);
        return;
      }

      const params = {
        offset,
        limit,
        searchTerm: searchTerm || undefined,
        itemType: activeFilter === 'all' ? undefined : activeFilter,
        ...filterParams,
      };

      const result = await AgentWorkspaceService.getQueue(params);

      if (result?.success && result.data) {
        const newItems = result.data.items || [];
        const newState = {
          loadingMore: false,
          refreshing: false,
          hasMore: result.data.hasmore,
          queueCounts: {
            totalcount: result.data.totalcount || 0,
            criticalcount: result.data.criticalcount || 0,
            warningcount: result.data.warningcount || 0,
            normalcount: result.data.normalcount || 0,
            waitingcount: result.data.waitingcount || 0,
          },
        };

        if (reset) {
          newState.queue = newItems;
          newState.offset = newItems.length;
        } else {
          newState.queue = [...queue, ...newItems];
          newState.offset = queue.length + newItems.length;
        }

        this.setState(newState);

        // Sincronizar queue com o contexto SignalR (apenas no reset para não duplicar)
        if (reset) {
          this.syncQueueWithContext(newState.queue);
        }
      } else {
        this.setState({ loadingMore: false, refreshing: false });
      }
    } catch (err) {
      PapiroConsole.log('Error loading queue', err);
      this.setState({ loadingMore: false, refreshing: false });
    }
  }

  async loadMoreByType(itemType) {
    const { calledItems, chatItems, limit, searchTerm, advancedFilters } = this.state;

    const isCalled = itemType === 'called';
    const currentItems = isCalled ? calledItems : chatItems;
    const offset = currentItems.length;
    const loadingKey = isCalled ? 'loadingMoreCalled' : 'loadingMoreChat';

    try {
      this.setState({ [loadingKey]: true });

      // Construir params de filtro
      const filterParams = {};
      if (advancedFilters.priorityId != null) filterParams.priorityId = advancedFilters.priorityId;
      if (advancedFilters.channelName) filterParams.channelName = advancedFilters.channelName;
      if (advancedFilters.messageProviderName) filterParams.messageProviderName = advancedFilters.messageProviderName;
      if (advancedFilters.urgencyGroup) filterParams.urgencyGroup = advancedFilters.urgencyGroup;
      if (advancedFilters.categoryName) filterParams.categoryName = advancedFilters.categoryName;
      if (advancedFilters.statusName) filterParams.statusName = advancedFilters.statusName;

      const result = await AgentWorkspaceService.getQueue({
        offset,
        limit,
        searchTerm: searchTerm || undefined,
        itemType,
        ...filterParams,
      });

      if (result?.success && result.data) {
        const newItems = result.data.items || [];
        const updatedItems = [...currentItems, ...newItems];

        if (isCalled) {
          this.setState({
            loadingMoreCalled: false,
            calledItems: updatedItems,
            calledHasMore: result.data.hasmore || false,
            // Atualizar queue combinada
            queue: [...updatedItems, ...chatItems],
          });
        } else {
          this.setState({
            loadingMoreChat: false,
            chatItems: updatedItems,
            chatHasMore: result.data.hasmore || false,
            // Atualizar queue combinada
            queue: [...calledItems, ...updatedItems],
          });
        }
      } else {
        this.setState({ [loadingKey]: false });
      }
    } catch (err) {
      PapiroConsole.log(`Error loading more ${itemType}`, err);
      this.setState({ [loadingKey]: false });
    }
  }

  async refreshData() {
    // Refresh silencioso - apenas métricas e reload da queue
    try {
      const metricsResult = await AgentWorkspaceService.getMetrics();
      if (metricsResult?.success && metricsResult.data) {
        this.setState({ metrics: metricsResult.data });
      }
      // Reload queue mantendo posição
      this.loadQueue(true);
    } catch (err) {
      PapiroConsole.log('Error refreshing data', err);
    }
  }

  handleScroll = (e) => {
    const { loadingMore, hasMore } = this.state;
    const element = e.target;
    const scrollBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

    // Carregar mais quando estiver a 200px do final
    if (scrollBottom < 200 && !loadingMore && hasMore) {
      this.loadQueue(false);
    }
  };

  handleSearchChange = (value) => {
    const { searchDebounceTimer } = this.state;

    // Limpar timer anterior
    if (searchDebounceTimer) clearTimeout(searchDebounceTimer);

    // Debounce de 500ms
    const timer = setTimeout(() => {
      this.loadQueue(true);
    }, 500);

    this.setState({ searchTerm: value, searchDebounceTimer: timer });
  };

  handleFilterChange = (filterType, value) => {
    if (filterType === 'activeFilter') {
      // Ao mudar o filtro principal, limpar filtros avançados e expandir todos os grupos
      const newAdvancedFilters = { priorityId: null, channelName: null, urgencyGroup: null, categoryName: null, statusName: null };
      this.setState({
        activeFilter: value,
        advancedFilters: newAdvancedFilters,
        expandedGroups: {
          called_critical: true, called_warning: true, called_normal: true, called_waiting: true,
          chat_critical: true, chat_warning: true, chat_normal: true, chat_waiting: true,
        }
      }, () => this.loadQueue(true, value, newAdvancedFilters));
    } else {
      this.setState(
        prev => {
          const newAdvancedFilters = { ...prev.advancedFilters, [filterType]: value };
          return { advancedFilters: newAdvancedFilters };
        },
        () => this.loadQueue(true)
      );
    }
  };

  clearAdvancedFilters = () => {
    this.setState({
      advancedFilters: { priorityId: null, channelName: null, messageProviderName: null, urgencyGroup: null, categoryName: null, statusName: null },
      filterMenuAnchor: null,
    }, () => this.loadQueue(true));
  };

  handleStatusChange = async (event) => {
    const { breakworks } = this.props;
    const { agentStatus } = this.state;
    const newStatus = event.target.value;

    const hasBreakreasonactive = !!breakworks?.breakreasonactive?.id;

    const conditions = [
      agentStatus == 2 && newStatus == 1 && hasBreakreasonactive, // Se estiver ocupado e for para disponível, e tiver motivo de pausa ativo
      agentStatus == 1 && newStatus == 3, // Se estiver disponível e for para pausado
      agentStatus == 3 && newStatus == 2 && hasBreakreasonactive, // Se estiver pausado e for para ocupado, e tiver motivo de pausa ativo
      agentStatus == 3 && newStatus == 1 && hasBreakreasonactive, // Se estiver pausado e for para disponível, e tiver motivo de pausa ativo
      agentStatus == 2 && newStatus == 3 // Se estiver ocupado e for para pausado
    ];

    if (conditions.some(cond => cond)) {
      this.openBreakReasonStartDialog(newStatus);
    } else {
      try {
        await AgentWorkspaceService.updateStatus(newStatus);
        this.setState({
          agentStatus: newStatus,
          openNotification: true,
          notificationVariant: 'success',
          notificationMessage: 'Status atualizado',
        });
      } catch (err) {
        this.setState({
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: 'Erro ao atualizar status',
        });
      }
    }
  };

  // Settings Dialog
  openSettingsDialog = () => {
    const { preferences } = this.state;
    this.setState({
      settingsOpen: true,
      tempPreferences: preferences ? { ...preferences } : {
        soundenabled: true,
        desktopnotificationsenabled: true,
        slacriticalalertsenabled: true,
        newmessagesoundenabled: true,
        displaydensity: 'normal',
        theme: 'auto',
        showwaitingcustomersection: true,
        defaultexpandedgroups: 'critical,warning',
        playmodeenabled: true,
        playmodeintervalseconds: 3,
        playmodeskipwaitingcustomer: true,
        playmodeautopauseminutes: null,
        playmodesoundenabled: true,
        keyboardshortcutsenabled: true,
        itemsperpage: 10,
        recentsmaxitems: 10,
        recentstimeminutes: 5,
      },
    });
  };

  handlePreferenceChange = async (key, value) => {
    // Se está habilitando notificações desktop, solicitar permissão
    if (key === 'desktopnotificationsenabled' && value === true) {
      if ("Notification" in window) {
        if (Notification.permission === "denied") {
          this.showNotification('warning', 'Notificações foram bloqueadas pelo navegador. Altere nas configurações do browser.');
          return; // Não atualiza o state
        }
        if (Notification.permission === "default") {
          const permission = await Notification.requestPermission();
          if (permission !== "granted") {
            this.showNotification('warning', 'Permissão de notificação negada');
            return; // Não atualiza o state
          }
        }
      } else {
        this.showNotification('warning', 'Seu navegador não suporta notificações desktop');
        return; // Não atualiza o state
      }
    }

    this.setState(prev => ({
      tempPreferences: { ...prev.tempPreferences, [key]: value }
    }));
  };

  savePreferences = async () => {
    const { tempPreferences } = this.state;
    try {
      this.setState({ savingPreferences: true });

      // Converter para formato da API (PascalCase)
      const apiPreferences = {
        SoundEnabled: tempPreferences.soundenabled,
        DesktopNotificationsEnabled: tempPreferences.desktopnotificationsenabled,
        SlaCriticalAlertsEnabled: tempPreferences.slacriticalalertsenabled,
        NewMessageSoundEnabled: tempPreferences.newmessagesoundenabled,
        DisplayDensity: tempPreferences.displaydensity,
        Theme: tempPreferences.theme,
        ShowWaitingCustomerSection: tempPreferences.showwaitingcustomersection,
        DefaultExpandedGroups: tempPreferences.defaultexpandedgroups,
        PlayModeEnabled: tempPreferences.playmodeenabled,
        PlayModeIntervalSeconds: tempPreferences.playmodeintervalseconds,
        PlayModeSkipWaitingCustomer: tempPreferences.playmodeskipwaitingcustomer,
        PlayModeAutoPauseMinutes: tempPreferences.playmodeautopauseminutes,
        PlayModeSoundEnabled: tempPreferences.playmodesoundenabled,
        KeyboardShortcutsEnabled: tempPreferences.keyboardshortcutsenabled,
        ItemsPerPage: tempPreferences.itemsperpage || 10,
        RecentsMaxItems: tempPreferences.recentsmaxitems || 10,
        RecentsTimeMinutes: tempPreferences.recentstimeminutes || 5,
      };

      const result = await AgentWorkspaceService.savePreferences(apiPreferences);

      if (result?.success) {
        // Atualizar grupos expandidos
        const expanded = tempPreferences.defaultexpandedgroups?.split(',') || [];
        const newLimit = tempPreferences.itemsperpage || 10;
        const limitChanged = newLimit !== this.state.limit;

        this.setState({
          preferences: tempPreferences,
          expandedGroups: {
            // Chamados
            called_critical: expanded.includes('critical'),
            called_warning: expanded.includes('warning'),
            called_normal: expanded.includes('normal'),
            called_waiting: expanded.includes('waiting'),
            // Chats
            chat_critical: expanded.includes('critical'),
            chat_warning: expanded.includes('warning'),
            chat_normal: expanded.includes('normal'),
            chat_waiting: expanded.includes('waiting'),
          },
          limit: newLimit,
          settingsOpen: false,
          savingPreferences: false,
          openNotification: true,
          notificationVariant: 'success',
          notificationMessage: 'Preferências salvas com sucesso',
        }, () => {
          // Recarregar a queue se o limite mudou
          if (limitChanged) {
            this.loadQueue(true);
          }
        });
      } else {
        throw new Error('Erro ao salvar');
      }
    } catch (err) {
      this.setState({
        savingPreferences: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: 'Erro ao salvar preferências',
      });
    }
  };

  // Stats Modal
  openStatsModal = () => {
    this.setState({ statsOpen: true });
  };

  // ===== VOIP — atalho de ligação (on-demand). Sem async em arrow field (babel 7.12.3): Promise chain. =====
  onVoipState = (e) => {
    const st = (e && e.detail) || (typeof window !== 'undefined' && window.__mexxVoip) || null;
    if (st) this.setState({ voipState: st });
  };

  _voipDigits = (v) => (v == null ? '' : String(v).replace(/\D/g, ''));

  // Busca o telefone do item (chamado→solicitante via /calleds/new; conversa→cliente via /chat/{id}) e abre o
  // modal de confirmação. Sem telefone válido → toast. A ligação real é feita pelo softphone global (evento voip:dial).
  handleDialClick = (item) => {
    if (!item || this.state.dialLoadingItemId != null) return;
    const itemKey = item.itemid ?? item.calledid ?? item.chatid;
    this.setState({ dialLoadingItemId: itemKey });

    const provider = (this.state.voipState && this.state.voipState.ramal && this.state.voipState.ramal.provider) || '';
    const openConfirm = (phone, name, calledId) => {
      if (this._voipDigits(phone).length < 10) {
        this.setState({ dialLoadingItemId: null, openNotification: true, notificationVariant: 'warning', notificationMessage: 'Contato sem telefone válido cadastrado.' });
        return;
      }
      this.setState({
        dialLoadingItemId: null,
        dialConfirm: { open: true, number: phone, providerName: provider, calledId: calledId || null, contact: { name: name || '', org: item.organizationname || '' } },
      });
    };
    const fail = (err) => {
      if (err) Api.kickoff(err);
      this.setState({ dialLoadingItemId: null, openNotification: true, notificationVariant: 'warning', notificationMessage: 'Não foi possível obter o telefone do contato.' });
    };

    if (item.itemtype === 1) {
      // Endpoint ENXUTO: só nome/telefone do cliente do chat (não a conversa inteira).
      Api2Talk.get(`/chat/${item.chatid}/customer-contact`)
        .then((res) => {
          const d = (res && res.data && (res.data.data || res.data)) || {};
          const phone = d.phone || d.customerphone || '';
          const name = d.name || d.customername || item.displaytitle || item.title || '';
          openConfirm(phone, name, null);
        })
        .catch((err) => fail(err));
    } else {
      // Endpoint ENXUTO: devolve só nome/telefone do solicitante (não o chamado inteiro do /new).
      Api.get(`/calleds/${item.calledid}/requester-contact`)
        .then((res) => {
          const d = (res && res.data && (res.data.data || res.data)) || {};
          const phone = d.phone || d.organizationphone || '';
          const name = d.name || item.requestingusername || '';
          openConfirm(phone, name, item.calledid || null);
        })
        .catch((err) => fail(err));
    }
  };

  closeDialConfirm = () => this.setState({ dialConfirm: { open: false, number: '', providerName: '', calledId: null, contact: null } });

  confirmDial = () => {
    const { number, contact, calledId } = this.state.dialConfirm;
    if (number) window.dispatchEvent(new CustomEvent('voip:dial', { detail: { number, contact, calledId } }));
    this.closeDialConfirm();
  };

  handleItemClick = (item) => {
    // Abre o modal de detalhes ao invés de navegar
    const isChatType = this.isChat(item.itemtype);

    // Preparar objeto do item para o modal
    const selectedItem = {
      id: isChatType ? item.chatid : item.calledid,
      type: isChatType ? 'chat' : 'called',
      calledId: item.calledid,
      chatId: item.chatid,
      title: item.title || '',
      displayTitle: item.displaytitle || item.title || '',
    };

    this.setState({
      detailsModalOpen: true,
      selectedItemForDetails: selectedItem,
    });
  };

  closeDetailsModal = () => {
    this.setState({
      detailsModalOpen: false,
      selectedItemForDetails: null,
    });
  };

  // === Tratamento Rápido ===
  openTreatCalledModal = (item) => {
    // Preparar dados do chamado para o modal de tratamento
    const calledData = {
      id: item.calledid || item.itemid,
      title: item.title || '',
      displayTitle: item.displaytitle || item.title || '',
      Organization: item.organizationname,
      OrganizationCategory: item.categoryname,
      organizationid: item.organizationid,
      status: {
        name: item.statusname,
        colorhex: item.statuscolor,
      },
      priority: {
        name: item.priorityname,
        colorhex: item.prioritycolor,
      },
      // Campos extras para exibição completa no modal
      requestingusername: item.requestingusername,
      requestinguseremail: item.requestinguseremail,
      openingdate: item.openingdate,
      duedate: item.duedate,
      typename: item.typename,
      departamentname: item.departamentname,
      addressname: item.addressname,
    };

    this.props.setTreatCalledModalData(calledData);
    this.setState({
      treatCalledModalOpen: true,
      calledToTreat: calledData,
    });
  };

  closeTreatCalledModal = () => {
    this.setState({ treatCalledModalOpen: false, calledToTreat: null });
  };

  // === Métodos do OmnichannelModal ===
  openOmnichannelModal = (item) => {
    this.setState({
      omnichannelModalOpen: true,
      selectedChatItem: item,
    });
  };

  closeOmnichannelModal = () => {
    this.setState({ omnichannelModalOpen: false, selectedChatItem: null });
  };

  // === Métodos do BreakReasonStartDialog ===
  openBreakReasonStartDialog = (newStatus) => {
    this.setState({ breakReasonStartOpen: true, selectedNewStatusForBreak: newStatus });
  };

  closeBreakReasonStartDialog = () => {
    this.setState({ breakReasonStartOpen: false });
  };

  handleSetStateBreakReasonStartDialog = (...props) => {
    let newState = {};

    if (!!props?.[0]) {
      const { loading, ...others } = props[0];

      newState = {
        ...others,
      };

      if (loading !== null) {
        newState.loadingHelper = loading;
      }
    }

    this.setState(newState);
  }

  handleChatClosed = async (chatId) => {
    // Remove o chat da lista local após encerramento/transferência (sem recarregar a queue)
    this.setState(prevState => {
      // Encontrar o item para saber qual contador decrementar
      const itemToRemove = prevState.queue.find(item => item.chatid === chatId);
      const urgencyGroup = itemToRemove ? this.normalizeUrgencyGroup(itemToRemove.urgencygroup) : null;

      // Decrementar o contador correto
      const newQueueCounts = { ...prevState.queueCounts };
      if (urgencyGroup) {
        const countKey = `${urgencyGroup}count`;
        if (newQueueCounts[countKey] > 0) {
          newQueueCounts[countKey] -= 1;
        }
        if (newQueueCounts.totalcount > 0) {
          newQueueCounts.totalcount -= 1;
        }
      }

      return {
        queue: prevState.queue.filter(item => item.chatid !== chatId),
        chatItems: prevState.chatItems.filter(item => item.chatid !== chatId),
        recentItems: prevState.recentItems.filter(item => item.chatid !== chatId),
        queueCounts: newQueueCounts,
      };
    });

    // Atualizar métricas
    const metricsResult = await AgentWorkspaceService.getMetrics();
    if (metricsResult?.success && metricsResult.data) {
      this.setState({ metrics: metricsResult.data });
    }
  };

  assignCalledForTreatment = async () => {
    const { calledToTreat } = this.state;
    const { userSession, intl } = this.props;

    if (!calledToTreat) {
      return false;
    }

    let data = new FormData();
    data.append("calledid", calledToTreat.id);
    data.append("userid", userSession.user.id);

    try {
      const result = await Api.post(`/calleds/canassignuser/team/treat`, data);

      if (result.data.success) {
        this.showNotification('success', intl.formatMessage({ id: "called.list.notification.called.taken" }));
        return true;
      }
      return false;
    } catch (err) {
      this.showNotification(
        'error',
        err.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
      );
      Api.kickoff(err);
      return false;
    }
  };

  removeCalledFromList = async (calledId) => {
    // Remove o chamado da lista local após encerramento (sem recarregar a queue)
    this.setState(prevState => {
      // Encontrar o item para saber qual contador decrementar
      const itemToRemove = prevState.queue.find(item => item.calledid === calledId);
      const urgencyGroup = itemToRemove ? this.normalizeUrgencyGroup(itemToRemove.urgencygroup) : null;

      // Decrementar o contador correto
      const newQueueCounts = { ...prevState.queueCounts };
      if (urgencyGroup) {
        const countKey = `${urgencyGroup}count`;
        if (newQueueCounts[countKey] > 0) {
          newQueueCounts[countKey] = newQueueCounts[countKey] - 1;
        }
        if (newQueueCounts.totalcount > 0) {
          newQueueCounts.totalcount = newQueueCounts.totalcount - 1;
        }
      }

      return {
        queue: prevState.queue.filter(item => item.calledid !== calledId),
        calledItems: prevState.calledItems.filter(item => item.calledid !== calledId),
        recentItems: prevState.recentItems.filter(item => item.calledid !== calledId),
        queueCounts: newQueueCounts,
      };
    });
    // Atualizar apenas as métricas (chamada leve, sem recarregar a lista)
    try {
      const metricsResult = await AgentWorkspaceService.getMetrics();
      if (metricsResult?.success && metricsResult.data) {
        this.setState({ metrics: metricsResult.data });
      }
    } catch (err) {
      console.error('Erro ao atualizar métricas:', err);
    }
  };

  handlePlayMode = async () => {
    try {
      const result = await AgentWorkspaceService.getNextItem();
      if (result?.success && result.data) {
        const item = result.data;
        const isChatType = this.isChat(item.itemtype);

        if (!isChatType) {
          // Chamado -> abre Tratamento Rápido
          this.openTreatCalledModal(item);
        } else {
          // Chat -> abre OmnichannelModal (mesma ação do botão "Entrar")
          this.openOmnichannelModal(item);
        }
      } else {
        this.showNotification('info', 'Nenhum item disponível na fila');
      }
    } catch (err) {
      this.showNotification('error', 'Erro ao buscar próximo item');
    }
  };

  showNotification = (variant, message) => {
    this.setState({
      openNotification: true,
      notificationVariant: variant,
      notificationMessage: message,
    });
  };

  toggleGroup = (group) => {
    this.setState(prev => ({
      expandedGroups: { ...prev.expandedGroups, [group]: !prev.expandedGroups[group] }
    }));
  };

  handleLayoutChange = (newLayout) => {
    this.setState({ layoutMode: newLayout });
    localStorage.setItem('agentWorkspace_layoutMode', newLayout);
  };

  // Helpers
  safeString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value.toLowerCase();
    return String(value).toLowerCase();
  }

  normalizeUrgencyGroup(urgencyGroup) {
    if (urgencyGroup == null) return 'normal';
    if (typeof urgencyGroup === 'number') {
      switch (urgencyGroup) {
        case 0: return 'critical';
        case 1: return 'warning';
        case 2: return 'normal';
        case 3: return 'waiting';
        default: return 'normal';
      }
    }
    if (typeof urgencyGroup === 'string') return urgencyGroup.toLowerCase();
    return 'normal';
  }

  isChat(itemType) {
    if (itemType == null) return false;
    // Handle string values (uppercase or lowercase)
    if (typeof itemType === 'string') {
      return itemType.toLowerCase() === 'chat';
    }
    // Handle numeric values (enum: Called=0, Chat=1)
    return itemType === 1;
  }

  getGroupedQueue(queueItems) {
    const groups = { critical: [], warning: [], normal: [], waiting: [] };

    (queueItems || []).forEach(item => {
      const group = this.normalizeUrgencyGroup(item.urgencygroup);
      if (groups[group]) {
        groups[group].push(item);
      } else {
        groups.normal.push(item);
      }
    });

    return groups;
  }

  getGroupedQueueByType(queueItems) {
    const result = {
      called: { critical: [], warning: [], normal: [], waiting: [], total: 0 },
      chat: { critical: [], warning: [], normal: [], waiting: [], total: 0 },
    };

    (queueItems || []).forEach(item => {
      const group = this.normalizeUrgencyGroup(item.urgencygroup);
      const isChat = this.isChat(item.itemtype);
      const typeKey = isChat ? 'chat' : 'called';

      if (result[typeKey][group]) {
        result[typeKey][group].push(item);
      } else {
        result[typeKey].normal.push(item);
      }
      result[typeKey].total++;
    });

    return result;
  }

  // Agrupa itens por urgência (usado para listas de um único tipo)
  groupByUrgency(items) {
    const result = { critical: [], warning: [], normal: [], waiting: [], total: 0 };

    (items || []).forEach(item => {
      const group = this.normalizeUrgencyGroup(item.urgencygroup);
      if (result[group]) {
        result[group].push(item);
      } else {
        result.normal.push(item);
      }
      result.total++;
    });

    return result;
  }

  getSlaColor(slaStatus) {
    const status = this.safeString(slaStatus);
    switch (status) {
      case 'critical':
      case 'breached':
      case '0':
        return '#ef4444';
      case 'warning':
      case '1':
        return '#f59e0b';
      default:
        return '#22c55e';
    }
  }

  getSlaPercent(item) {
    if (!item.sla || !item.sla.percentage) return 0;
    return Math.min(100, Math.max(0, item.sla.percentage));
  }

  getChannelIcon(channelName) {
    const density = this.getDensityStyles();
    const channel = this.safeString(channelName);
    if (channel.includes('email')) return <EmailIcon style={{ color: '#EA4335', fontSize: density.iconSize }} />;
    if (channel.includes('phone') || channel.includes('telefone')) return <PhoneIcon style={{ color: '#3b82f6', fontSize: density.iconSize }} />;
    // Ícone padrão para canal
    return <RouterIcon style={{ color: '#6b7280', fontSize: density.iconSize }} />;
  }

  getProviderIcon(providerName) {
    const density = this.getDensityStyles();
    const provider = this.safeString(providerName);
    if (provider.includes('whatsapp')) return <WhatsAppIcon style={{ color: '#25D366', fontSize: density.iconSize }} />;
    if (provider.includes('instagram')) return <InstagramIcon style={{ color: '#E4405F', fontSize: density.iconSize }} />;
    if (provider.includes('facebook') || provider.includes('messenger')) return <FacebookIcon style={{ color: '#0084FF', fontSize: density.iconSize }} />;
    if (provider.includes('telegram')) return <TelegramIcon style={{ color: '#0088cc', fontSize: density.iconSize }} />;
    if (provider.includes('webchat') || provider.includes('web')) return <LanguageIcon style={{ color: '#6b7280', fontSize: density.iconSize }} />;
    // Ícone padrão para provedor
    return <MessageIcon style={{ color: '#6b7280', fontSize: density.iconSize }} />;
  }

  getUserInitials() {
    const { userSession } = this.props;
    const name = userSession?.user?.fullname || userSession?.user?.name || 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  getDensityStyles() {
    const { preferences } = this.state;
    const density = preferences?.displaydensity || 'normal';

    const configs = {
      compact: {
        cardPadding: '8px 12px',
        cardMargin: '4px',
        titleSize: '12px',
        previewSize: '11px',
        metaSize: '10px',
        badgeSize: '10px',
        iconSize: 12,
        gap: '4px',
      },
      normal: {
        cardPadding: '14px 16px',
        cardMargin: '8px',
        titleSize: '14px',
        previewSize: '13px',
        metaSize: '11px',
        badgeSize: '11px',
        iconSize: 14,
        gap: '8px',
      },
      comfortable: {
        cardPadding: '20px 24px',
        cardMargin: '12px',
        titleSize: '16px',
        previewSize: '14px',
        metaSize: '12px',
        badgeSize: '12px',
        iconSize: 16,
        gap: '12px',
      },
    };

    return configs[density] || configs.normal;
  }

  getThemeStyles() {
    const { preferences } = this.state;
    let theme = preferences?.theme || 'light';

    // Handle 'auto' theme
    if (theme === 'auto') {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      theme = prefersDark ? 'dark' : 'light';
    }

    const themes = {
      light: {
        background: '#f8fafc',
        contentBg: '#fff',
        cardBg: '#fff',
        text: '#1a1a2e',
        textSecondary: '#6b7280',
        border: '#e5e7eb',
        urgencyGroupBg: '#fff',
        sidebarBg: '#fff',
      },
      dark: {
        background: '#1a1a2e',
        contentBg: '#252540',
        cardBg: '#2d2d4a',
        text: '#f8fafc',
        textSecondary: '#a1a1aa',
        border: '#3d3d5c',
        urgencyGroupBg: '#2d2d4a',
        sidebarBg: '#252540',
      },
    };

    return themes[theme] || themes.light;
  }

  getUserName() {
    const { userSession } = this.props;
    return userSession?.user?.fullname || userSession?.user?.name || 'Usuário';
  }

  renderWorkItem(item) {
    const { classes } = this.props;
    const isChat = this.isChat(item.itemtype);
    const urgency = this.normalizeUrgencyGroup(item.urgencygroup);
    const slaColor = this.getSlaColor(item.sla?.status);
    const slaPercent = this.getSlaPercent(item);
    const density = this.getDensityStyles();

    const accentClass = {
      critical: classes.bgCritical,
      warning: classes.bgWarning,
      normal: classes.bgNormal,
      waiting: classes.bgWaiting,
    }[urgency] || classes.bgNormal;

    const themeStyles = this.getThemeStyles();

    // ID a exibir: para chat usa chatid, para chamado usa calledid ou itemid
    const displayId = isChat ? (item.chatid || item.itemid) : (item.calledid || item.itemid);

    return (
      <Box
        key={`${item.itemtype}-${item.itemid}`}
        className={`${classes.workItemCard} ${item._isNew ? classes.workItemCardNew : ''}`}
        style={{ padding: density.cardPadding, marginBottom: density.cardMargin, background: item._isNew ? undefined : themeStyles.cardBg, borderColor: item._isNew ? '#22c55e' : themeStyles.border, cursor: 'default' }}
      >
        <Box className={`${classes.itemAccent} ${accentClass}`} />
        <Box className={classes.itemContent}>
          <Box className={classes.itemHeader}>
            <Box style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: density.gap }}>
              <Box className={`${classes.itemTypeBadge} ${isChat ? classes.itemTypeChat : classes.itemTypeCalled}`} style={{ fontSize: density.badgeSize }}>
                {isChat ? <ChatIcon style={{ fontSize: density.iconSize }} /> : <AssignmentIcon style={{ fontSize: density.iconSize }} />}
                {isChat ? `Chat #${displayId}` : `Chamado #${displayId}`}
              </Box>
              {item.iswaitingcustomer && (
                <Box className={classes.waitingCustomerBadge} style={{ fontSize: density.badgeSize }}>
                  <HourglassEmptyIcon style={{ fontSize: density.iconSize - 2 }} />
                  Aguardando
                </Box>
              )}
              {item.priorityname && (
                <Tooltip title="Prioridade" arrow>
                  <Box
                    className={classes.priorityBadge}
                    style={{
                      background: item.prioritycolor ? `${item.prioritycolor}20` : '#f3f4f6',
                      color: item.prioritycolor || '#6b7280',
                      fontSize: density.badgeSize,
                    }}
                  >
                    {item.priorityname}
                  </Box>
                </Tooltip>
              )}
            </Box>
            {item.unreadcount > 0 && (
              <Tooltip title={`${item.unreadcount} ${item.unreadcount === 1 ? 'mensagem não lida' : 'mensagens não lidas'}`} arrow>
                <Chip
                  size="small"
                  label={item.unreadcount}
                  sx={{ background: '#ef4444', color: '#fff', height: 20, fontSize: density.badgeSize, fontWeight: 700 }}
                />
              </Tooltip>
            )}
          </Box>

          <Box className={classes.itemTitleRow}>
            <Typography className={classes.itemTitle} style={{ fontSize: density.titleSize, color: themeStyles.text }}>
              {item.displaytitle || item.title || `#${item.itemid}`}
            </Typography>
          </Box>

          {item.lastmessagepreview && (
            <Typography className={classes.itemPreview} style={{ fontSize: density.previewSize, color: themeStyles.textSecondary }}>
              "{item.lastmessagepreview}"
            </Typography>
          )}

          <Box className={classes.itemMeta} style={{ fontSize: density.metaSize, color: themeStyles.textSecondary }}>
            {item.statusname && (
              <Tooltip title="Status" arrow>
                <Box className={classes.itemMetaItem} style={{
                  background: item.statuscolor ? `${item.statuscolor}20` : '#e5e7eb',
                  color: item.statuscolor || '#6b7280',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontWeight: 500,
                }}>
                  <FiberManualRecordIcon style={{ fontSize: 8 }} />
                  {item.statusname}
                </Box>
              </Tooltip>
            )}
            {item.organizationname && (
              <Tooltip title="Organização" arrow>
                <Box className={classes.itemMetaItem}>
                  <BusinessIcon style={{ fontSize: density.iconSize }} />
                  {item.organizationname}
                </Box>
              </Tooltip>
            )}
            {item.categoryname && (
              <Tooltip title="Categoria" arrow>
                <Box className={classes.itemMetaItem}>
                  <CategoryIcon style={{ fontSize: density.iconSize }} />
                  {item.categoryname}
                </Box>
              </Tooltip>
            )}
            {item.channelname && (
              <Tooltip title="Canal" arrow>
                <Box className={classes.itemMetaItem}>
                  {this.getChannelIcon(item.channelname)}
                  {item.channelname}
                </Box>
              </Tooltip>
            )}
            {isChat && item.messageprovidername && (
              <Tooltip title="Provedor" arrow>
                <Box className={classes.itemMetaItem}>
                  {this.getProviderIcon(item.messageprovidername)}
                  {item.messageprovidername}
                </Box>
              </Tooltip>
            )}
            {isChat && item.techinicalteamname && (
              <Tooltip title="Time" arrow>
                <Box className={classes.itemMetaItem}>
                  <GroupsIcon style={{ fontSize: density.iconSize }} />
                  {item.techinicalteamname}
                </Box>
              </Tooltip>
            )}
          </Box>
        </Box>

        <Box className={classes.itemRight}>
          <Tooltip title="SLA" arrow>
            <Box className={classes.slaSection}>
              <Typography className={classes.slaTime} style={{ color: slaColor }}>
                {item.sla?.remainingformatted || 'N/A'}
              </Typography>
              <Box className={classes.slaBar}>
                <Box
                  className={classes.slaBarFill}
                  style={{
                    width: `${100 - slaPercent}%`,
                    background: slaColor,
                  }}
                />
              </Box>
            </Box>
          </Tooltip>

          <Box className={classes.waitingTime}>
            <AccessTimeIcon style={{ fontSize: 12 }} />
            {item.waitingtimeformatted || '0s'}
          </Box>

          <Box style={{ display: 'flex', gap: 4 }}>
            {!isChat && (
              <Tooltip title="Tratamento Rápido" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', minWidth: 'auto' }} onClick={(e) => { e.stopPropagation(); this.openTreatCalledModal(item); }}>
                  <QuickreplyIcon style={{ fontSize: 16, color: 'inherit' }} />
                </button>
              </Tooltip>
            )}
            {isChat && (
              <Tooltip title="Entrar no chat" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', background: '#3b82f6' }} onClick={(e) => { e.stopPropagation(); this.openOmnichannelModal(item); }}>
                  <LoginIcon style={{ fontSize: 14, marginRight: 4, color: 'inherit' }} /> Entrar
                </button>
              </Tooltip>
            )}
            {this.state.voipState && this.state.voipState.hasRamal && (
              <Tooltip title="Ligar para o contato" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', minWidth: 'auto' }} disabled={this.state.dialLoadingItemId != null} onClick={(e) => { e.stopPropagation(); this.handleDialClick(item); }}>
                  {this.state.dialLoadingItemId === (item.itemid ?? item.calledid ?? item.chatid)
                    ? <CircularProgress size={15} style={{ color: 'inherit' }} />
                    : <PhoneIcon style={{ fontSize: 16, color: 'inherit' }} />}
                </button>
              </Tooltip>
            )}
            <Tooltip title="Visualizar detalhes" arrow>
              <button className={classes.openButton} onClick={(e) => { e.stopPropagation(); this.handleItemClick(item); }}>
                <VisibilityIcon style={{ fontSize: 14, marginRight: 4, color: 'inherit' }} /> Abrir
              </button>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    );
  }

  renderWorkItemGrid(item) {
    const { classes } = this.props;
    const isChat = this.isChat(item.itemtype);
    const urgency = this.normalizeUrgencyGroup(item.urgencygroup);
    const slaColor = this.getSlaColor(item.sla?.status);
    const density = this.getDensityStyles();
    const themeStyles = this.getThemeStyles();

    // ID a exibir: para chat usa chatid, para chamado usa calledid ou itemid
    const displayId = isChat ? (item.chatid || item.itemid) : (item.calledid || item.itemid);

    const accentClass = {
      critical: classes.bgCritical,
      warning: classes.bgWarning,
      normal: classes.bgNormal,
      waiting: classes.bgWaiting,
    }[urgency] || classes.bgNormal;

    return (
      <Box
        key={`${item.itemtype}-${item.itemid}`}
        className={`${classes.workItemCardGrid} ${item._isNew ? classes.workItemCardNew : ''}`}
        style={{ cursor: 'default', padding: density.cardPadding, background: item._isNew ? undefined : themeStyles.cardBg, borderColor: item._isNew ? '#22c55e' : themeStyles.border }}
      >
        <Box className={`${classes.gridCardAccent} ${accentClass}`} />

        <Box className={classes.gridCardHeader}>
          <Box className={`${classes.itemTypeBadge} ${isChat ? classes.itemTypeChat : classes.itemTypeCalled}`} style={{ fontSize: density.badgeSize }}>
            {isChat ? <ChatIcon style={{ fontSize: density.iconSize - 2 }} /> : <AssignmentIcon style={{ fontSize: density.iconSize - 2 }} />}
            {isChat ? `Chat #${displayId}` : `Chamado #${displayId}`}
          </Box>
          {item.unreadcount > 0 && (
            <Tooltip title={`${item.unreadcount} ${item.unreadcount === 1 ? 'mensagem não lida' : 'mensagens não lidas'}`} arrow>
              <Chip
                size="small"
                label={item.unreadcount}
                sx={{ background: '#ef4444', color: '#fff', height: 18, fontSize: density.badgeSize, fontWeight: 700 }}
              />
            </Tooltip>
          )}
        </Box>

        <Typography className={classes.gridCardTitle} style={{ fontSize: density.titleSize, color: themeStyles.text }}>
          {item.displaytitle || item.title || `#${item.itemid}`}
        </Typography>

        <Box className={classes.gridCardMeta} style={{ fontSize: density.metaSize, color: themeStyles.textSecondary }}>
          {item.statusname && (
            <Tooltip title="Status" arrow>
              <Box className={classes.gridCardMetaItem} style={{
                background: item.statuscolor ? `${item.statuscolor}20` : '#e5e7eb',
                color: item.statuscolor || '#6b7280',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: 500,
              }}>
                <FiberManualRecordIcon style={{ fontSize: 6 }} />
                <span>{item.statusname}</span>
              </Box>
            </Tooltip>
          )}
          {item.organizationname && (
            <Tooltip title="Organização" arrow>
              <Box className={classes.gridCardMetaItem}>
                <BusinessIcon style={{ fontSize: density.iconSize }} />
                <span>{item.organizationname}</span>
              </Box>
            </Tooltip>
          )}
          {item.categoryname && (
            <Tooltip title="Categoria" arrow>
              <Box className={classes.gridCardMetaItem}>
                <CategoryIcon style={{ fontSize: density.iconSize }} />
                <span>{item.categoryname}</span>
              </Box>
            </Tooltip>
          )}
          {item.channelname && (
            <Tooltip title="Canal" arrow>
              <Box className={classes.gridCardMetaItem}>
                {this.getChannelIcon(item.channelname)}
                <span>{item.channelname}</span>
              </Box>
            </Tooltip>
          )}
          {isChat && item.messageprovidername && (
            <Tooltip title="Provedor" arrow>
              <Box className={classes.gridCardMetaItem}>
                {this.getProviderIcon(item.messageprovidername)}
                <span>{item.messageprovidername}</span>
              </Box>
            </Tooltip>
          )}
          {isChat && item.techinicalteamname && (
            <Tooltip title="Time" arrow>
              <Box className={classes.gridCardMetaItem}>
                <GroupsIcon style={{ fontSize: density.iconSize }} />
                <span>{item.techinicalteamname}</span>
              </Box>
            </Tooltip>
          )}
        </Box>

        <Box className={classes.gridCardFooter}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tooltip title="SLA" arrow>
              <Box className={classes.gridSlaChip} style={{ background: `${slaColor}15`, color: slaColor }}>
                <AccessTimeIcon style={{ fontSize: 12 }} />
                {item.sla?.remainingformatted || 'N/A'}
              </Box>
            </Tooltip>
            <Box className={classes.waitingTime}>
              {item.waitingtimeformatted || '0s'}
            </Box>
          </Box>
          <Box style={{ display: 'flex', gap: 4 }}>
            {!isChat && (
              <Tooltip title="Tratamento Rápido" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', minWidth: 'auto', opacity: 1 }} onClick={(e) => { e.stopPropagation(); this.openTreatCalledModal(item); }}>
                  <QuickreplyIcon style={{ fontSize: 16, color: 'inherit' }} />
                </button>
              </Tooltip>
            )}
            {isChat && (
              <Tooltip title="Entrar no chat" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', background: '#3b82f6', opacity: 1 }} onClick={(e) => { e.stopPropagation(); this.openOmnichannelModal(item); }}>
                  <LoginIcon style={{ fontSize: 14, marginRight: 4, color: 'inherit' }} /> Entrar
                </button>
              </Tooltip>
            )}
            {this.state.voipState && this.state.voipState.hasRamal && (
              <Tooltip title="Ligar para o contato" arrow>
                <button className={classes.openButton} style={{ padding: '6px 8px', minWidth: 'auto', opacity: 1 }} disabled={this.state.dialLoadingItemId != null} onClick={(e) => { e.stopPropagation(); this.handleDialClick(item); }}>
                  {this.state.dialLoadingItemId === (item.itemid ?? item.calledid ?? item.chatid)
                    ? <CircularProgress size={15} style={{ color: 'inherit' }} />
                    : <PhoneIcon style={{ fontSize: 16, color: 'inherit' }} />}
                </button>
              </Tooltip>
            )}
            <Tooltip title="Visualizar detalhes" arrow>
              <button
                className={classes.openButton}
                style={{ opacity: 1 }}
                onClick={() => this.handleItemClick(item)}
              >
                <VisibilityIcon style={{ fontSize: 14, marginRight: 4, color: 'inherit' }} /> Abrir
              </button>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    );
  }

  renderTypeSection(typeKey, typeGroups, themeStyles) {
    const { classes } = this.props;
    const { calledHasMore, chatHasMore, loadingMoreCalled, loadingMoreChat } = this.state;
    const isChat = typeKey === 'chat';
    const title = isChat ? 'CONVERSAS' : 'CHAMADOS';
    const total = typeGroups.total;
    const headerColor = isChat ? '#3b82f6' : '#8b5cf6';
    const headerBg = isChat ? '#eff6ff' : '#f5f3ff';
    const hasMore = isChat ? chatHasMore : calledHasMore;
    const isLoadingMore = isChat ? loadingMoreChat : loadingMoreCalled;

    if (total === 0) return null;

    const urgencyConfigs = {
      critical: {
        headerClass: classes.urgencyHeaderCritical,
        icon: <ErrorOutlineIcon className={classes.urgencyIcon} style={{ color: '#ef4444' }} />,
        title: 'Crítico',
        color: '#ef4444',
      },
      warning: {
        headerClass: classes.urgencyHeaderWarning,
        icon: <WarningAmberIcon className={classes.urgencyIcon} style={{ color: '#f59e0b' }} />,
        title: 'Atenção',
        color: '#f59e0b',
      },
      normal: {
        headerClass: classes.urgencyHeaderNormal,
        icon: <CheckCircleOutlineIcon className={classes.urgencyIcon} style={{ color: '#22c55e' }} />,
        title: 'Normal',
        color: '#22c55e',
      },
      waiting: {
        headerClass: classes.urgencyHeaderWaiting,
        icon: <HourglassEmptyIcon className={classes.urgencyIcon} style={{ color: '#64748b' }} />,
        title: 'Aguardando Cliente',
        color: '#64748b',
      },
    };

    return (
      <Box key={typeKey} style={{ marginBottom: 20 }}>
        <Box style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '12px 16px',
          background: headerBg,
          borderRadius: '10px',
          marginBottom: 12,
        }}>
          {isChat ? <ChatIcon style={{ color: headerColor, fontSize: 20 }} /> : <AssignmentIcon style={{ color: headerColor, fontSize: 20 }} />}
          <Typography style={{ fontSize: 14, fontWeight: 700, color: headerColor, letterSpacing: '0.5px' }}>
            {title}
          </Typography>
          <Box style={{
            background: headerColor,
            color: '#fff',
            padding: '2px 10px',
            borderRadius: '12px',
            fontSize: 12,
            fontWeight: 700,
          }}>
            {total}
          </Box>
        </Box>
        {['critical', 'warning', 'normal', 'waiting'].map(urgencyKey => {
          const items = typeGroups[urgencyKey];
          if (!items || items.length === 0) return null;
          // Usar chave composta para separar collapse de Chamados e Chats
          const compositeKey = `${typeKey}_${urgencyKey}`;
          return this.renderUrgencyGroup(compositeKey, items, {
            ...urgencyConfigs[urgencyKey],
            count: items.length,
          });
        })}
        {/* Botão Carregar Mais */}
        {hasMore && (
          <Box style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
            <Button
              variant="outlined"
              size="small"
              disabled={isLoadingMore}
              onClick={() => this.loadMoreByType(typeKey)}
              style={{
                borderColor: headerColor,
                color: headerColor,
                textTransform: 'none',
                fontSize: 13,
                padding: '6px 16px',
              }}
            >
              {isLoadingMore ? (
                <>
                  <CircularProgress size={16} style={{ marginRight: 8, color: headerColor }} />
                  Carregando...
                </>
              ) : (
                `Carregar mais ${isChat ? 'conversas' : 'chamados'}`
              )}
            </Button>
          </Box>
        )}
      </Box>
    );
  }

  renderUrgencyGroup(groupKey, items, config) {
    const { classes } = this.props;
    const { expandedGroups, layoutMode, preferences } = this.state;
    const themeStyles = this.getThemeStyles();

    // Se não mostrar seção aguardando cliente e for o grupo waiting, retornar null
    if (groupKey === 'waiting' && preferences && !preferences.showwaitingcustomersection) {
      return null;
    }

    if (!items || items.length === 0) return null;

    // Usar count do config (vindo do backend) se disponível, senão usar items.length
    const displayCount = config.count !== undefined ? config.count : items.length;

    return (
      <Box className={classes.urgencyGroup} style={{ background: themeStyles.urgencyGroupBg, borderColor: themeStyles.border }}>
        <Box
          className={`${classes.urgencyHeader} ${config.headerClass}`}
          onClick={() => this.toggleGroup(groupKey)}
        >
          <Box className={classes.urgencyHeaderLeft}>
            {config.icon}
            <Typography className={classes.urgencyTitle} style={{ color: config.color }}>
              {config.title}
            </Typography>
            <Box className={classes.urgencyCount} style={{ background: config.color }}>
              {displayCount}
            </Box>
          </Box>
          {expandedGroups[groupKey] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
        <Collapse in={expandedGroups[groupKey]}>
          <Box className={layoutMode === 'grid' ? classes.itemsGrid : classes.itemsList}>
            {items.map(item => layoutMode === 'grid' ? this.renderWorkItemGrid(item) : this.renderWorkItem(item))}
          </Box>
        </Collapse>
      </Box>
    );
  }

  render() {
    const { classes, userSession, agentWorkspaceHub, breakworks } = this.props;
    const {
      loading, refreshing, loadingMore, metrics, queue, queueCounts, hasMore, agentStatus, activeFilter,
      searchTerm, expandedGroups, advancedFilters, filterOptions, preferences, tempPreferences,
      settingsOpen, statsOpen, savingPreferences, notificationsAnchor, filterMenuAnchor,
      recentItems, recentsPanelOpen
    } = this.state;

    // Notificações do Context SignalR
    const recentNotifications = agentWorkspaceHub?.recentNotifications || [];
    const unreadNotificationCount = agentWorkspaceHub?.unreadNotificationCount || 0;

    const groupedQueue = this.getGroupedQueue(queue);

    const hasActiveFilters = advancedFilters.priorityId || advancedFilters.channelName || advancedFilters.messageProviderName || advancedFilters.urgencyGroup || advancedFilters.categoryName || advancedFilters.statusName;
    const activeFilterCount = [
      advancedFilters.priorityId,
      advancedFilters.channelName,
      advancedFilters.messageProviderName,
      advancedFilters.urgencyGroup,
      advancedFilters.categoryName,
      advancedFilters.statusName,
    ].filter(Boolean).length;

    const statusOptions = [
      { value: 1, label: 'Disponível', color: '#22c55e' },
      { value: 2, label: 'Ocupado', color: '#f59e0b' },
      { value: 3, label: 'Pausado', color: '#ef4444' },
    ];

    if (loading) {
      return (
        <Base>
          <Box className={classes.mainContainer}>
            {/* Skeleton Sidebar */}
            <Box className={classes.sidebar}>
              {[1, 2, 3].map((i) => (
                <Paper key={i} className={classes.sidebarCard} elevation={0}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <Skeleton variant="rounded" width={36} height={36} animation="wave" />
                    <Skeleton variant="text" width={40} height={32} animation="wave" />
                  </Box>
                  <Skeleton variant="text" width={80} height={16} animation="wave" />
                </Paper>
              ))}
              <Paper className={classes.sidebarCard} elevation={0} style={{ marginTop: 8 }}>
                <Skeleton variant="text" width={100} height={20} animation="wave" style={{ marginBottom: 12 }} />
                {[1, 2, 3, 4].map((i) => (
                  <Box key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                    <Skeleton variant="text" width={60} height={16} animation="wave" />
                    <Skeleton variant="text" width={24} height={16} animation="wave" />
                  </Box>
                ))}
              </Paper>
            </Box>

            {/* Skeleton Main Content */}
            <Box className={classes.mainContent} style={{ flex: 1 }}>
              {/* Skeleton Header */}
              <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <Skeleton variant="rounded" width={200} height={40} animation="wave" />
                  <Skeleton variant="rounded" width={100} height={32} animation="wave" />
                </Box>
                <Box style={{ display: 'flex', gap: 8 }}>
                  <Skeleton variant="circular" width={40} height={40} animation="wave" />
                  <Skeleton variant="circular" width={40} height={40} animation="wave" />
                  <Skeleton variant="circular" width={40} height={40} animation="wave" />
                </Box>
              </Box>

              {/* Skeleton Cards */}
              <Paper style={{ borderRadius: 16, padding: 16, background: '#fff' }} elevation={0}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                  <Skeleton variant="rounded" width={24} height={24} animation="wave" />
                  <Skeleton variant="text" width={80} height={24} animation="wave" />
                  <Skeleton variant="rounded" width={32} height={20} animation="wave" style={{ borderRadius: 10 }} />
                </Box>
                {[1, 2, 3, 4].map((i) => (
                  <Box key={i} style={{ display: 'flex', padding: '16px 0', borderBottom: i < 4 ? '1px solid #f0f0f0' : 'none' }}>
                    <Skeleton variant="rounded" width={4} height={60} animation="wave" style={{ marginRight: 16, borderRadius: 4 }} />
                    <Box style={{ flex: 1 }}>
                      <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <Skeleton variant="rounded" width={100} height={24} animation="wave" style={{ borderRadius: 6 }} />
                        <Skeleton variant="rounded" width={60} height={20} animation="wave" style={{ borderRadius: 4 }} />
                      </Box>
                      <Skeleton variant="text" width="60%" height={20} animation="wave" style={{ marginBottom: 4 }} />
                      <Box style={{ display: 'flex', gap: 12 }}>
                        <Skeleton variant="text" width={80} height={16} animation="wave" />
                        <Skeleton variant="text" width={100} height={16} animation="wave" />
                        <Skeleton variant="text" width={60} height={16} animation="wave" />
                      </Box>
                    </Box>
                    <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                      <Skeleton variant="text" width={50} height={20} animation="wave" />
                      <Skeleton variant="rounded" width={100} height={6} animation="wave" style={{ borderRadius: 3 }} />
                      <Skeleton variant="rounded" width={70} height={28} animation="wave" style={{ borderRadius: 6 }} />
                    </Box>
                  </Box>
                ))}
              </Paper>
            </Box>
          </Box>
        </Base>
      );
    }

    const themeStyles = this.getThemeStyles();

    return (
      <Base>
        <Box className={classes.mainContainer} style={{ background: themeStyles.background }}>
          {/* Sidebar */}
          <Box className={classes.sidebar}>
            <Paper
              className={`${classes.sidebarCard} ${classes.sidebarCardClickable} ${activeFilter === 'chat' ? classes.sidebarCardActiveChat : ''}`}
              onClick={() => this.handleFilterChange('activeFilter', activeFilter === 'chat' ? 'all' : 'chat')}
              elevation={0}
              style={{ background: themeStyles.sidebarBg, borderColor: themeStyles.border }}
            >
              <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <Box style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: activeFilter === 'chat' ? '#3b82f6' : '#eff6ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <ChatIcon style={{ fontSize: 18, color: activeFilter === 'chat' ? '#fff' : '#3b82f6' }} />
                </Box>
                <Typography className={classes.sidebarValue} style={{ color: '#3b82f6', fontSize: 28 }}>
                  {metrics?.activechats || 0}
                </Typography>
              </Box>
              <Typography className={classes.sidebarLabel} style={{ color: themeStyles.textSecondary }}>Conversas ativas</Typography>
            </Paper>

            <Paper
              className={`${classes.sidebarCard} ${classes.sidebarCardClickable} ${activeFilter === 'called' ? classes.sidebarCardActiveCalled : ''}`}
              onClick={() => this.handleFilterChange('activeFilter', activeFilter === 'called' ? 'all' : 'called')}
              elevation={0}
              style={{ background: themeStyles.sidebarBg, borderColor: themeStyles.border }}
            >
              <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <Box style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: activeFilter === 'called' ? '#8b5cf6' : '#f5f3ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <AssignmentIcon style={{ fontSize: 18, color: activeFilter === 'called' ? '#fff' : '#8b5cf6' }} />
                </Box>
                <Typography className={classes.sidebarValue} style={{ color: '#8b5cf6', fontSize: 28 }}>
                  {metrics?.opencalleds || 0}
                </Typography>
              </Box>
              <Typography className={classes.sidebarLabel} style={{ color: themeStyles.textSecondary }}>Chamados abertos</Typography>
            </Paper>

            <Paper className={`${classes.sidebarCard} ${classes.sidebarCardInfo}`} elevation={0} style={{ background: themeStyles.sidebarBg, borderColor: themeStyles.border }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <Box style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: '#fef3c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <AccessTimeIcon style={{ fontSize: 18, color: '#d97706' }} />
                </Box>
                <Typography className={classes.sidebarValue} style={{ color: themeStyles.text, fontSize: 28 }}>
                  {this.formatSmartTime(metrics?.avgresponsetimeseconds)}
                </Typography>
              </Box>
              <Typography className={classes.sidebarLabel} style={{ color: themeStyles.textSecondary }}>Tempo médio</Typography>
            </Paper>

            <Paper className={`${classes.sidebarCard} ${classes.sidebarCardInfo}`} elevation={0} style={{ background: themeStyles.sidebarBg, borderColor: themeStyles.border }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <Box style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: (metrics?.slacompliancetodaypercent || 0) >= 80 ? '#dcfce7' : '#fef2f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <SpeedIcon style={{ fontSize: 18, color: (metrics?.slacompliancetodaypercent || 0) >= 80 ? '#16a34a' : '#dc2626' }} />
                </Box>
                <Typography className={classes.sidebarValue} style={{ color: (metrics?.slacompliancetodaypercent || 0) >= 80 ? '#22c55e' : '#ef4444', fontSize: 28 }}>
                  {(metrics?.slacompliancetodaypercent || 0).toFixed(0)}%
                </Typography>
              </Box>
              <Typography className={classes.sidebarLabel} style={{ color: themeStyles.textSecondary }}>SLA Hoje</Typography>
            </Paper>

            <Divider className={classes.sidebarDivider} style={{ borderColor: themeStyles.border }} />

            <Box
              className={classes.sidebarAction}
              onClick={this.handlePlayMode}
              style={{ background: themeStyles.sidebarBg }}
            >
              <Box className={classes.sidebarActionIcon} style={{ background: '#eff6ff' }}>
                <PlayArrowIcon style={{ color: '#3b82f6' }} />
              </Box>
              <Typography style={{ fontSize: 13, fontWeight: 600, color: themeStyles.text }}>Atender próximo</Typography>
            </Box>

            <Box
              className={classes.sidebarAction}
              onClick={() => this.handleStatusChange({ target: { value: agentStatus === 3 ? 1 : 3 } })}
              style={{ background: themeStyles.sidebarBg }}
            >
              <Box className={classes.sidebarActionIcon} style={{ background: agentStatus === 3 ? '#f0fdf4' : '#fef2f2' }}>
                {agentStatus === 3 ? <PlayArrowIcon style={{ color: '#22c55e' }} /> : <PauseIcon style={{ color: '#ef4444' }} />}
              </Box>
              <Typography style={{ fontSize: 13, fontWeight: 600, color: themeStyles.text }}>
                {agentStatus === 3 ? 'Retomar Distribuição' : 'Pausar Distribuição'}
              </Typography>
            </Box>

            <Box className={classes.sidebarAction} onClick={this.openStatsModal} style={{ background: themeStyles.sidebarBg }}>
              <Box className={classes.sidebarActionIcon} style={{ background: '#faf5ff' }}>
                <BarChartIcon style={{ color: '#8b5cf6' }} />
              </Box>
              <Typography style={{ fontSize: 13, fontWeight: 600, color: themeStyles.text }}>Stats</Typography>
            </Box>
          </Box>

          {/* Main Area */}
          <Box className={classes.mainArea}>
            {/* Header Bar */}
            <Paper className={classes.headerBar} elevation={0} style={{ background: themeStyles.cardBg, borderColor: themeStyles.border }}>
              <Box className={classes.headerLeft}>
                <Box className={classes.userInfo}>
                  <Avatar className={classes.userAvatar}>{this.getUserInitials()}</Avatar>
                  <Typography className={classes.userName} style={{ color: themeStyles.text }}>{this.getUserName()}</Typography>
                </Box>

                <FormControl size="small">
                  <Select
                    value={agentStatus}
                    onChange={this.handleStatusChange}
                    className={classes.statusSelect}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {statusOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        <Box className={classes.statusDot} style={{ background: opt.color }} />
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box className={classes.headerRight}>
                {(metrics?.criticalcount || 0) > 0 && (
                  <Box
                    className={`${classes.alertBadge} ${classes.alertCritical}`}
                    onClick={() => {
                      this.handleFilterChange('urgencyGroup', 'critical');
                      this.setState({ expandedGroups: { ...expandedGroups, called_critical: true, chat_critical: true } });
                    }}
                  >
                    <ErrorOutlineIcon style={{ fontSize: 16 }} />
                    {metrics.criticalcount} Críticos
                  </Box>
                )}
                {(metrics?.slanearbreachcount || 0) > 0 && (
                  <Box
                    className={`${classes.alertBadge} ${classes.alertWarning}`}
                    onClick={() => {
                      this.handleFilterChange('urgencyGroup', 'warning');
                      this.setState({ expandedGroups: { ...expandedGroups, called_warning: true, chat_warning: true } });
                    }}
                  >
                    <AccessTimeIcon style={{ fontSize: 16 }} />
                    {metrics.slanearbreachcount} SLA Próximo
                  </Box>
                )}

                <Tooltip title="Configurações">
                  <IconButton
                    className={classes.headerIconButton}
                    onClick={this.openSettingsDialog}
                  >
                    <SettingsIcon style={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Notificações">
                  <IconButton
                    className={classes.headerIconButton}
                    onClick={(e) => {
                      this.setState({ notificationsAnchor: e.currentTarget });
                      // Marcar todas como lidas ao abrir o menu
                      if (agentWorkspaceHub?.markAllNotificationsAsRead) {
                        agentWorkspaceHub.markAllNotificationsAsRead();
                      }
                    }}
                  >
                    <Badge badgeContent={unreadNotificationCount} color="error" max={99}>
                      <NotificationsIcon style={{ fontSize: 20 }} />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Atualizar">
                  <IconButton
                    className={classes.headerIconButton}
                    onClick={() => { this.setState({ refreshing: true }); this.refreshData(); }}
                    disabled={refreshing}
                  >
                    {refreshing ? <CircularProgress size={20} /> : <RefreshIcon style={{ fontSize: 20 }} />}
                  </IconButton>
                </Tooltip>
              </Box>
            </Paper>

            {/* Filter Bar */}
            <Paper className={classes.filterBar} elevation={0} style={{ background: themeStyles.cardBg, borderColor: themeStyles.border }}>
              <Box className={classes.filterTabs}>
                <Box
                  className={classes.filterTab}
                  onClick={() => this.handleFilterChange('activeFilter', 'all')}
                  style={activeFilter === 'all' ? { background: 'var(--mexx-green-primary, #8BC34A)', borderColor: 'var(--mexx-green-primary, #8BC34A)', color: '#fff' } : {}}
                >
                  Todos
                  <Box className={classes.filterTabCount} style={{
                    background: activeFilter === 'all' ? 'rgba(255,255,255,0.2)' : '#f3f4f6',
                    color: activeFilter === 'all' ? '#fff' : '#6b7280'
                  }}>
                    {metrics?.totalitems || 0}
                  </Box>
                </Box>
                <Box
                  className={classes.filterTab}
                  onClick={() => this.handleFilterChange('activeFilter', 'called')}
                  style={activeFilter === 'called' ? { background: 'var(--mexx-green-primary, #8BC34A)', borderColor: 'var(--mexx-green-primary, #8BC34A)', color: '#fff' } : {}}
                >
                  <AssignmentIcon style={{ fontSize: 16 }} />
                  Chamados
                  <Box className={classes.filterTabCount} style={{
                    background: activeFilter === 'called' ? 'rgba(255,255,255,0.2)' : '#f3f4f6',
                    color: activeFilter === 'called' ? '#fff' : '#6b7280'
                  }}>
                    {metrics?.opencalleds || 0}
                  </Box>
                </Box>
                <Box
                  className={classes.filterTab}
                  onClick={() => this.handleFilterChange('activeFilter', 'chat')}
                  style={activeFilter === 'chat' ? { background: 'var(--mexx-green-primary, #8BC34A)', borderColor: 'var(--mexx-green-primary, #8BC34A)', color: '#fff' } : {}}
                >
                  <ChatIcon style={{ fontSize: 16 }} />
                  Conversas
                  <Box className={classes.filterTabCount} style={{
                    background: activeFilter === 'chat' ? 'rgba(255,255,255,0.2)' : '#f3f4f6',
                    color: activeFilter === 'chat' ? '#fff' : '#6b7280'
                  }}>
                    {metrics?.activechats || 0}
                  </Box>
                </Box>
              </Box>

              <Box className={classes.filterRight}>
                <TextField
                  placeholder="Buscar..."
                  size="small"
                  value={searchTerm}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                  className={classes.searchField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: '#9ca3af', fontSize: 18 }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Badge badgeContent={hasActiveFilters ? '!' : 0} color="primary">
                  <Button
                    className={classes.filterButton}
                    startIcon={<FilterListIcon style={{ fontSize: 16 }} />}
                    onClick={(e) => this.setState({ filterMenuAnchor: e.currentTarget })}
                  >
                    Filtros
                  </Button>
                </Badge>

                {/* Layout Toggle */}
                <Box className={classes.layoutToggle}>
                  <Tooltip title="Visualização em lista">
                    <Box
                      component="button"
                      className={`${classes.layoutToggleButton} ${this.state.layoutMode === 'list' ? classes.layoutToggleActive : ''}`}
                      onClick={() => this.handleLayoutChange('list')}
                    >
                      <ViewListIcon style={{ fontSize: 20 }} />
                    </Box>
                  </Tooltip>
                  <Tooltip title="Visualização em grade">
                    <Box
                      component="button"
                      className={`${classes.layoutToggleButton} ${this.state.layoutMode === 'grid' ? classes.layoutToggleActive : ''}`}
                      onClick={() => this.handleLayoutChange('grid')}
                    >
                      <GridViewIcon style={{ fontSize: 20 }} />
                    </Box>
                  </Tooltip>
                </Box>
              </Box>
            </Paper>

            {/* Active Filters Indicator */}
            {hasActiveFilters && (
              <Box className={classes.activeFiltersBar}>
                <FilterListIcon style={{ fontSize: 16, color: '#1d4ed8' }} />
                <Typography className={classes.activeFiltersText}>
                  Filtros ativos
                </Typography>
                <Button
                  size="small"
                  onClick={this.clearAdvancedFilters}
                  style={{ marginLeft: 'auto', textTransform: 'none', fontSize: 12 }}
                >
                  Limpar filtros
                </Button>
              </Box>
            )}

            {/* Queue Groups */}
            <Box
              className={classes.scrollableContainer}
              onScroll={this.handleScroll}
              ref={this.listContainerRef}
              style={{ maxHeight: 'calc(100vh - 320px)' }}
            >
              {queue.length === 0 && !loadingMore ? (
                <Box style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 'calc(100vh - 380px)',
                  background: '#f8fafc',
                  borderRadius: 12,
                  border: '1px dashed #e5e7eb'
                }}>
                  <Box className={classes.emptyIcon}>
                    <CheckCircleOutlineIcon />
                  </Box>
                  <Typography style={{ fontSize: 16, fontWeight: 600, color: '#1a1a2e', marginBottom: 4 }}>
                    Fila vazia
                  </Typography>
                  <Typography style={{ fontSize: 14, color: '#6b7280' }}>
                    Nenhum item pendente no momento
                  </Typography>
                </Box>
              ) : activeFilter === 'all' ? (
                <>
                  {/* Blocos separados por tipo quando "Todos" está selecionado */}
                  {(() => {
                    const { calledItems, chatItems } = this.state;
                    // Agrupar cada tipo por urgência
                    const groupedCalled = this.groupByUrgency(calledItems);
                    const groupedChat = this.groupByUrgency(chatItems);
                    return (
                      <>
                        {this.renderTypeSection('called', groupedCalled, themeStyles)}
                        {this.renderTypeSection('chat', groupedChat, themeStyles)}
                      </>
                    );
                  })()}
                </>
              ) : (
                <>
                  {this.renderUrgencyGroup('critical', groupedQueue.critical, {
                    headerClass: classes.urgencyHeaderCritical,
                    icon: <ErrorOutlineIcon className={classes.urgencyIcon} style={{ color: '#ef4444' }} />,
                    title: 'Crítico',
                    color: '#ef4444',
                    count: queueCounts.criticalcount,
                  })}
                  {this.renderUrgencyGroup('warning', groupedQueue.warning, {
                    headerClass: classes.urgencyHeaderWarning,
                    icon: <WarningAmberIcon className={classes.urgencyIcon} style={{ color: '#f59e0b' }} />,
                    title: 'Atenção',
                    color: '#f59e0b',
                    count: queueCounts.warningcount,
                  })}
                  {this.renderUrgencyGroup('normal', groupedQueue.normal, {
                    headerClass: classes.urgencyHeaderNormal,
                    icon: <CheckCircleOutlineIcon className={classes.urgencyIcon} style={{ color: '#22c55e' }} />,
                    title: 'Normal',
                    color: '#22c55e',
                    count: queueCounts.normalcount,
                  })}
                  {this.renderUrgencyGroup('waiting', groupedQueue.waiting, {
                    headerClass: classes.urgencyHeaderWaiting,
                    icon: <HourglassEmptyIcon className={classes.urgencyIcon} style={{ color: '#64748b' }} />,
                    title: 'Aguardando Cliente',
                    color: '#64748b',
                    count: queueCounts.waitingcount,
                  })}

                  {/* Loading more indicator */}
                  {loadingMore && (
                    <Box className={classes.loadingMore}>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                </>
              )}
            </Box>
          </Box>

          {/* Painel de Recentes (direita) */}
          <Box
            className={`${classes.recentsPanel} ${!recentsPanelOpen ? classes.recentsPanelCollapsed : ''}`}
            onClick={!recentsPanelOpen ? this.toggleRecentsPanel : undefined}
            style={!recentsPanelOpen ? { background: themeStyles.cardBg, border: `1px solid ${themeStyles.border}`, borderRadius: '12px' } : undefined}
          >
            <Box
              className={`${classes.recentsPanelHeader} ${!recentsPanelOpen ? classes.recentsPanelHeaderCollapsed : ''}`}
              onClick={recentsPanelOpen ? this.toggleRecentsPanel : undefined}
            >
              {recentsPanelOpen ? (
                <>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Box sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '8px',
                      background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(34, 197, 94, 0.3)',
                    }}>
                      <HistoryIcon style={{ fontSize: 16, color: '#fff' }} />
                    </Box>
                    <Typography className={classes.recentsPanelTitle}>
                      Recentes
                    </Typography>
                    {recentItems.length > 0 && (
                      <Box sx={{
                        background: '#dcfce7',
                        color: '#166534',
                        padding: '2px 8px',
                        borderRadius: '10px',
                        fontSize: 11,
                        fontWeight: 700,
                      }}>
                        {recentItems.length}
                      </Box>
                    )}
                  </Box>
                  <KeyboardArrowRightIcon
                    style={{
                      fontSize: 20,
                      color: '#16a34a',
                      transition: 'transform 0.2s ease',
                    }}
                  />
                </>
              ) : (
                <>
                  <Badge
                    badgeContent={recentItems.length}
                    color="success"
                    sx={{ '& .MuiBadge-badge': { fontSize: 10, height: 16, minWidth: 16 } }}
                  >
                    <HistoryIcon style={{ fontSize: 18, color: '#22c55e' }} />
                  </Badge>
                  <Typography className={`${classes.recentsPanelTitle} ${classes.recentsPanelTitleCollapsed}`}>
                    Recentes
                  </Typography>
                </>
              )}
            </Box>

            {recentsPanelOpen && (
              <Box className={classes.recentsPanelContent}>
                {recentItems.length === 0 ? (
                  <Box className={classes.recentsPanelEmpty}>
                    <HistoryIcon style={{ fontSize: 36, color: '#d1d5db', marginBottom: 12 }} />
                    <Typography style={{ fontSize: 13, color: '#9ca3af', fontWeight: 500 }}>
                      Nenhum item recente
                    </Typography>
                    <Typography style={{ fontSize: 11, color: '#d1d5db', marginTop: 6 }}>
                      Novos itens aparecerão aqui
                    </Typography>
                  </Box>
                ) : (
                  recentItems.map((item) => {
                    const timeRemaining = this.getRecentItemTimeRemaining(item);
                    const isExpiring = timeRemaining < 60; // menos de 1 min
                    const isChat = item.itemtype === 1;

                    return (
                      <Box
                        key={`recent-${item.itemid}-${item.itemtype}-${item._recentAddedAt}`}
                        className={`${classes.recentItem} ${item._isNew ? classes.recentItemNew : ''}`}
                        onClick={() => this.handleRecentItemClick(item)}
                        style={{ background: themeStyles.cardBg, borderColor: themeStyles.border }}
                      >
                        <Box className={classes.recentItemHeader}>
                          <Typography className={classes.recentItemTitle} style={{ color: themeStyles.text }}>
                            {item.displaytitle || item.title || `#${item.itemid}`}
                          </Typography>
                          <Box className={`${classes.recentItemTimer} ${isExpiring ? classes.recentItemTimerExpiring : ''}`}>
                            <AccessTimeIcon style={{ fontSize: 10 }} />
                            {this.formatRecentTimeRemaining(timeRemaining)}
                          </Box>
                        </Box>
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                          <Box className={`${classes.recentItemType} ${isChat ? classes.recentItemTypeChat : classes.recentItemTypeCalled}`}>
                            {isChat ? <ChatIcon style={{ fontSize: 10 }} /> : <AssignmentIcon style={{ fontSize: 10 }} />}
                            {isChat ? 'Conversa' : 'Chamado'}
                          </Box>
                          <Typography className={classes.recentItemSubtitle}>
                            {item.organizationname || item.requestingusername || ''}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* Settings Dialog */}
        <Dialog
          open={settingsOpen}
          onClose={() => this.setState({ settingsOpen: false })}
          maxWidth="sm"
          fullWidth
          PaperProps={{ style: { background: themeStyles.cardBg, color: themeStyles.text } }}
        >
          <DialogTitle style={{ color: themeStyles.text }}>Configurações</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}>
            {tempPreferences && (
              <>
                {/* Notificações */}
                <Box className={classes.preferenceSection}>
                  <Typography className={classes.preferenceSectionTitle}>Notificações</Typography>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Sons de notificação</Typography>
                      <Typography className={classes.preferenceDescription}>Tocar som ao receber novos itens</Typography>
                    </Box>
                    <Switch
                      checked={tempPreferences.soundenabled}
                      onChange={(e) => this.handlePreferenceChange('soundenabled', e.target.checked)}
                    />
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Notificações desktop</Typography>
                      <Typography className={classes.preferenceDescription}>Mostrar notificações do navegador</Typography>
                    </Box>
                    <Switch
                      checked={tempPreferences.desktopnotificationsenabled}
                      onChange={(e) => this.handlePreferenceChange('desktopnotificationsenabled', e.target.checked)}
                    />
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Alertas SLA crítico</Typography>
                      <Typography className={classes.preferenceDescription}>Alertar quando SLA estiver crítico</Typography>
                    </Box>
                    <Switch
                      checked={tempPreferences.slacriticalalertsenabled}
                      onChange={(e) => this.handlePreferenceChange('slacriticalalertsenabled', e.target.checked)}
                    />
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Som nova mensagem</Typography>
                      <Typography className={classes.preferenceDescription}>Tocar som ao receber mensagens</Typography>
                    </Box>
                    <Switch
                      checked={tempPreferences.newmessagesoundenabled}
                      onChange={(e) => this.handlePreferenceChange('newmessagesoundenabled', e.target.checked)}
                    />
                  </Box>
                </Box>

                {/* Modo Play */}
                <Box className={classes.preferenceSection} style={{ opacity: 0.6 }}>
                  <Typography className={classes.preferenceSectionTitle}>
                    Modo Play
                    <Chip size="small" label="Em breve" sx={{ ml: 1, fontSize: 10, height: 18, background: '#e0e7ff', color: '#4338ca' }} />
                  </Typography>

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>Modo Play habilitado</Typography>
                        <Typography className={classes.preferenceDescription}>Navegar automaticamente para próximo item</Typography>
                      </Box>
                      <Switch
                        checked={tempPreferences.playmodeenabled}
                        disabled
                      />
                    </Box>
                  </Tooltip>

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>Intervalo entre itens (segundos)</Typography>
                        <Typography className={classes.preferenceDescription}>Tempo de espera antes de avançar para o próximo</Typography>
                      </Box>
                      <Select
                        size="small"
                        value={tempPreferences.playmodeintervalseconds || 3}
                        disabled
                        style={{ minWidth: 80 }}
                      >
                        <MenuItem value={1}>1s</MenuItem>
                        <MenuItem value={2}>2s</MenuItem>
                        <MenuItem value={3}>3s</MenuItem>
                        <MenuItem value={5}>5s</MenuItem>
                        <MenuItem value={10}>10s</MenuItem>
                      </Select>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>Auto-pausar após (minutos)</Typography>
                        <Typography className={classes.preferenceDescription}>Pausar automaticamente após período de inatividade</Typography>
                      </Box>
                      <Select
                        size="small"
                        value={tempPreferences.playmodeautopauseminutes || 0}
                        disabled
                        style={{ minWidth: 100 }}
                      >
                        <MenuItem value={0}>Desativado</MenuItem>
                        <MenuItem value={5}>5 min</MenuItem>
                        <MenuItem value={10}>10 min</MenuItem>
                        <MenuItem value={15}>15 min</MenuItem>
                        <MenuItem value={30}>30 min</MenuItem>
                      </Select>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>Pular aguardando cliente</Typography>
                        <Typography className={classes.preferenceDescription}>Ignorar itens aguardando resposta do cliente</Typography>
                      </Box>
                      <Switch
                        checked={tempPreferences.playmodeskipwaitingcustomer}
                        disabled
                      />
                    </Box>
                  </Tooltip>

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>Som do Play Mode</Typography>
                        <Typography className={classes.preferenceDescription}>Tocar som ao avançar para próximo item</Typography>
                      </Box>
                      <Switch
                        checked={tempPreferences.playmodesoundenabled}
                        disabled
                      />
                    </Box>
                  </Tooltip>
                </Box>

                {/* Visual */}
                <Box className={classes.preferenceSection}>
                  <Typography className={classes.preferenceSectionTitle}>Visual</Typography>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Tema</Typography>
                      <Typography className={classes.preferenceDescription}>Aparência visual da interface</Typography>
                    </Box>
                    <Select
                      size="small"
                      value={tempPreferences.theme || 'auto'}
                      onChange={(e) => this.handlePreferenceChange('theme', e.target.value)}
                      style={{ minWidth: 120 }}
                    >
                      <MenuItem value="auto">Automático</MenuItem>
                      <MenuItem value="light">Claro</MenuItem>
                      <MenuItem value="dark">Escuro</MenuItem>
                    </Select>
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Densidade da visualização</Typography>
                      <Typography className={classes.preferenceDescription}>Espaçamento entre elementos</Typography>
                    </Box>
                    <Select
                      size="small"
                      value={tempPreferences.displaydensity || 'normal'}
                      onChange={(e) => this.handlePreferenceChange('displaydensity', e.target.value)}
                      style={{ minWidth: 120 }}
                    >
                      <MenuItem value="compact">Compacto</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="comfortable">Confortável</MenuItem>
                    </Select>
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Grupos expandidos por padrão</Typography>
                      <Typography className={classes.preferenceDescription}>Quais grupos abrir automaticamente</Typography>
                    </Box>
                    <Select
                      size="small"
                      multiple
                      value={(tempPreferences.defaultexpandedgroups || 'critical,warning').split(',')}
                      onChange={(e) => this.handlePreferenceChange('defaultexpandedgroups', e.target.value.join(','))}
                      style={{ minWidth: 150 }}
                      renderValue={(selected) => selected.map(s => s === 'critical' ? 'Crítico' : s === 'warning' ? 'Atenção' : s === 'normal' ? 'Normal' : 'Aguardando').join(', ')}
                    >
                      <MenuItem value="critical">Crítico</MenuItem>
                      <MenuItem value="warning">Atenção</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="waiting">Aguardando</MenuItem>
                    </Select>
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Mostrar seção "Aguardando Cliente"</Typography>
                      <Typography className={classes.preferenceDescription}>Exibir grupo separado para itens aguardando</Typography>
                    </Box>
                    <Switch
                      checked={tempPreferences.showwaitingcustomersection}
                      onChange={(e) => this.handlePreferenceChange('showwaitingcustomersection', e.target.checked)}
                    />
                  </Box>

                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle2" sx={{ mb: 1, color: '#6b7280' }}>Paginação e Recentes</Typography>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Itens por página</Typography>
                      <Typography className={classes.preferenceDescription}>Quantidade de itens na lista principal</Typography>
                    </Box>
                    <Select
                      size="small"
                      value={tempPreferences.itemsperpage || 10}
                      onChange={(e) => this.handlePreferenceChange('itemsperpage', e.target.value)}
                      style={{ minWidth: 80 }}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Máx. itens recentes</Typography>
                      <Typography className={classes.preferenceDescription}>Quantidade de itens no painel Recentes</Typography>
                    </Box>
                    <Select
                      size="small"
                      value={tempPreferences.recentsmaxitems || 10}
                      onChange={(e) => this.handlePreferenceChange('recentsmaxitems', e.target.value)}
                      style={{ minWidth: 80 }}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </Box>

                  <Box className={classes.preferenceItem}>
                    <Box>
                      <Typography className={classes.preferenceLabel}>Tempo dos recentes</Typography>
                      <Typography className={classes.preferenceDescription}>Tempo que itens ficam visíveis em Recentes</Typography>
                    </Box>
                    <Select
                      size="small"
                      value={tempPreferences.recentstimeminutes || 5}
                      onChange={(e) => this.handlePreferenceChange('recentstimeminutes', e.target.value)}
                      style={{ minWidth: 100 }}
                    >
                      <MenuItem value={1}>1 min</MenuItem>
                      <MenuItem value={3}>3 min</MenuItem>
                      <MenuItem value={5}>5 min</MenuItem>
                      <MenuItem value={10}>10 min</MenuItem>
                      <MenuItem value={15}>15 min</MenuItem>
                      <MenuItem value={30}>30 min</MenuItem>
                    </Select>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  <Tooltip title="Recurso em desenvolvimento" arrow placement="left">
                    <Box className={classes.preferenceItem} style={{ opacity: 0.6 }}>
                      <Box>
                        <Typography className={classes.preferenceLabel} style={{ color: '#9ca3af' }}>
                          Atalhos de teclado
                          <Chip size="small" label="Em breve" sx={{ ml: 1, fontSize: 10, height: 18, background: '#e0e7ff', color: '#4338ca' }} />
                        </Typography>
                        <Typography className={classes.preferenceDescription}>Habilitar atalhos de teclado</Typography>
                      </Box>
                      <Switch
                        checked={tempPreferences.keyboardshortcutsenabled}
                        disabled
                      />
                    </Box>
                  </Tooltip>
                </Box>
              </>
            )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ settingsOpen: false })}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={this.savePreferences}
              disabled={savingPreferences}
            >
              {savingPreferences ? <CircularProgress size={20} /> : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Stats Modal */}
        <Dialog
          open={statsOpen}
          onClose={() => this.setState({ statsOpen: false })}
          maxWidth="sm"
          fullWidth
          PaperProps={{ style: { background: themeStyles.cardBg, color: themeStyles.text } }}
        >
          <DialogTitle style={{ color: themeStyles.text }}>Estatísticas do Dia</DialogTitle>
          <DialogContent>
            <Box className={classes.statsGrid}>
              <Box className={classes.statCard}>
                <Typography className={classes.statValue} style={{ color: '#22c55e' }}>
                  {metrics?.itemsclosedtoday || 0}
                </Typography>
                <Typography className={classes.statLabel}>Itens fechados hoje</Typography>
              </Box>

              <Box className={classes.statCard}>
                <Typography className={classes.statValue} style={{ color: '#3b82f6' }}>
                  {this.formatSmartTime(metrics?.avgresponsetimeseconds)}
                </Typography>
                <Typography className={classes.statLabel}>Tempo médio de resposta</Typography>
              </Box>

              <Box className={classes.statCard}>
                <Typography
                  className={classes.statValue}
                  style={{ color: (metrics?.slacompliancetodaypercent || 0) >= 80 ? '#22c55e' : '#ef4444' }}
                >
                  {(metrics?.slacompliancetodaypercent || 0).toFixed(0)}%
                </Typography>
                <Typography className={classes.statLabel}>SLA Compliance</Typography>
              </Box>

              <Box className={classes.statCard}>
                <Typography className={classes.statValue} style={{ color: '#8b5cf6' }}>
                  {(metrics?.activechats || 0) + (metrics?.opencalleds || 0)}
                </Typography>
                <Typography className={classes.statLabel}>Total na fila</Typography>
              </Box>
            </Box>

            <Divider style={{ marginBottom: 20 }} />

            <Typography style={{ fontWeight: 600, marginBottom: 12 }}>Distribuição por Urgência</Typography>
            <Box style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Chip
                icon={<ErrorOutlineIcon style={{ color: '#ef4444' }} />}
                label={`Crítico: ${queueCounts.criticalcount || 0}`}
                style={{ background: '#fef2f2', color: '#dc2626' }}
              />
              <Chip
                icon={<WarningAmberIcon style={{ color: '#f59e0b' }} />}
                label={`Atenção: ${queueCounts.warningcount || 0}`}
                style={{ background: '#fffbeb', color: '#d97706' }}
              />
              <Chip
                icon={<CheckCircleOutlineIcon style={{ color: '#22c55e' }} />}
                label={`Normal: ${queueCounts.normalcount || 0}`}
                style={{ background: '#f0fdf4', color: '#16a34a' }}
              />
              <Chip
                icon={<HourglassEmptyIcon style={{ color: '#64748b' }} />}
                label={`Aguardando: ${queueCounts.waitingcount || 0}`}
                style={{ background: '#f8fafc', color: '#475569' }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ statsOpen: false })}>Fechar</Button>
          </DialogActions>
        </Dialog>

        {/* Notifications Menu */}
        <Menu
          anchorEl={notificationsAnchor}
          open={Boolean(notificationsAnchor)}
          onClose={() => this.setState({ notificationsAnchor: null })}
          PaperProps={{
            style: {
              width: 380,
              maxHeight: 500,
              borderRadius: 12,
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              background: themeStyles.cardBg,
              color: themeStyles.text,
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box style={{ padding: '16px 20px', borderBottom: `1px solid ${themeStyles.border}` }}>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: 16, fontWeight: 700, color: themeStyles.text }}>Notificações</Typography>
              {recentNotifications.length > 0 && (
                <Button
                  size="small"
                  onClick={() => {
                    if (agentWorkspaceHub?.clearNotifications) {
                      agentWorkspaceHub.clearNotifications();
                    }
                  }}
                  style={{ textTransform: 'none', fontSize: 12, color: '#6b7280' }}
                >
                  Limpar todas
                </Button>
              )}
            </Box>
          </Box>

          <Box style={{ maxHeight: 380, overflowY: 'auto' }}>
            {/* Lista de notificações recentes */}
            {recentNotifications.length > 0 ? (
              recentNotifications.slice(0, 15).map((notif) => {
                // Calcular tempo relativo
                const getRelativeTime = (timestamp) => {
                  if (!timestamp) return '';
                  const now = new Date();
                  const date = new Date(timestamp);
                  const diffMs = now - date;
                  const diffSec = Math.floor(diffMs / 1000);
                  const diffMin = Math.floor(diffSec / 60);
                  const diffHour = Math.floor(diffMin / 60);
                  const diffDay = Math.floor(diffHour / 24);

                  if (diffSec < 60) return 'Agora';
                  if (diffMin < 60) return `${diffMin}min atrás`;
                  if (diffHour < 24) return `${diffHour}h atrás`;
                  return `${diffDay}d atrás`;
                };

                // Ícone baseado no tipo
                const getNotificationIcon = (type) => {
                  switch (type) {
                    case 'new_item':
                      return { bg: '#eff6ff', color: '#3b82f6', icon: <AssignmentIcon style={{ fontSize: 18, color: '#3b82f6' }} /> };
                    case 'sla_critical':
                      return { bg: '#fef2f2', color: '#ef4444', icon: <ErrorOutlineIcon style={{ fontSize: 18, color: '#ef4444' }} /> };
                    case 'new_message':
                      return { bg: '#f0fdf4', color: '#22c55e', icon: <ChatIcon style={{ fontSize: 18, color: '#22c55e' }} /> };
                    default:
                      return { bg: '#f3f4f6', color: '#6b7280', icon: <NotificationsIcon style={{ fontSize: 18, color: '#6b7280' }} /> };
                  }
                };

                const iconConfig = getNotificationIcon(notif.type);

                return (
                  <Box
                    key={notif.id}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 12,
                      padding: '14px 20px',
                      borderBottom: '1px solid #f3f4f6',
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                      opacity: notif.read ? 0.7 : 1,
                    }}
                    onClick={() => {
                      this.setState({ notificationsAnchor: null });
                      // Abrir modal apropriado baseado no tipo
                      if (notif.item && notif.type === 'new_item') {
                        const isChat = notif.itemType === 1;
                        if (isChat) {
                          // Chat -> abre OmnichannelModal
                          this.openOmnichannelModal(notif.item);
                        } else {
                          // Chamado -> abre Tratamento Rápido
                          this.openTreatCalledModal(notif.item);
                        }
                      } else if (notif.type === 'new_message' && notif.chatId) {
                        // Nova mensagem -> filtrar para chats e abrir omnichannel
                        const chatItem = this.state.queue.find(q => q.itemid === notif.chatId && q.itemtype === 1);
                        if (chatItem) {
                          this.openOmnichannelModal(chatItem);
                        } else {
                          this.handleFilterChange('activeFilter', 'chat');
                        }
                      } else if (notif.type === 'sla_critical' && notif.item) {
                        // SLA crítico -> abre tratamento rápido ou omnichannel
                        const isChat = notif.itemType === 1;
                        if (isChat) {
                          this.openOmnichannelModal(notif.item);
                        } else {
                          this.openTreatCalledModal(notif.item);
                        }
                      }
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = themeStyles.hoverBg || '#fafafa'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <Box style={{
                      width: 36,
                      height: 36,
                      borderRadius: 8,
                      background: iconConfig.bg,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      {iconConfig.icon}
                    </Box>
                    <Box style={{ flex: 1, minWidth: 0 }}>
                      <Typography style={{
                        fontSize: 13,
                        fontWeight: notif.read ? 400 : 600,
                        color: themeStyles.text,
                        marginBottom: 2,
                        lineHeight: 1.4,
                      }}>
                        {notif.message}
                      </Typography>
                      <Typography style={{ fontSize: 11, color: '#9ca3af' }}>
                        {getRelativeTime(notif.timestamp)}
                      </Typography>
                    </Box>
                    {!notif.read && (
                      <Box style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: '#3b82f6',
                        flexShrink: 0,
                        marginTop: 6,
                      }} />
                    )}
                  </Box>
                );
              })
            ) : (
              <Box style={{ padding: '40px 20px', textAlign: 'center' }}>
                <Box style={{
                  width: 56,
                  height: 56,
                  borderRadius: 14,
                  background: '#f0fdf4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 12px',
                }}>
                  <CheckCircleOutlineIcon style={{ fontSize: 28, color: '#22c55e' }} />
                </Box>
                <Typography style={{ fontSize: 14, fontWeight: 600, color: themeStyles.text, marginBottom: 4 }}>
                  Sem notificações
                </Typography>
                <Typography style={{ fontSize: 13, color: '#6b7280' }}>
                  Você será notificado quando novos itens forem atribuídos
                </Typography>
              </Box>
            )}
          </Box>

          {/* Alertas fixos (críticos e SLA) */}
          {((metrics?.criticalcount || 0) > 0 || (metrics?.slanearbreachcount || 0) > 0) && (
            <Box style={{ borderTop: `1px solid ${themeStyles.border}`, padding: '12px 20px', background: themeStyles.cardBg }}>
              <Typography style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>
                Alertas Ativos
              </Typography>
              <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {(metrics?.criticalcount || 0) > 0 && (
                  <Chip
                    size="small"
                    icon={<ErrorOutlineIcon style={{ fontSize: 14 }} />}
                    label={`${metrics.criticalcount} crítico${metrics.criticalcount > 1 ? 's' : ''}`}
                    onClick={() => {
                      this.setState({ notificationsAnchor: null, expandedGroups: { ...expandedGroups, called_critical: true, chat_critical: true } });
                      this.handleFilterChange('urgencyGroup', 'critical');
                    }}
                    sx={{ background: '#fef2f2', color: '#dc2626', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}
                  />
                )}
                {(metrics?.slanearbreachcount || 0) > 0 && (
                  <Chip
                    size="small"
                    icon={<AccessTimeIcon style={{ fontSize: 14 }} />}
                    label={`${metrics.slanearbreachcount} SLA em risco`}
                    onClick={() => {
                      this.setState({ notificationsAnchor: null, expandedGroups: { ...expandedGroups, called_warning: true, chat_warning: true } });
                      this.handleFilterChange('urgencyGroup', 'warning');
                    }}
                    sx={{ background: '#fffbeb', color: '#d97706', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}
                  />
                )}
              </Box>
            </Box>
          )}

          <Box style={{ padding: '10px 20px', borderTop: '1px solid #f3f4f6', background: themeStyles.hoverBg || '#fafafa' }}>
            <Button
              fullWidth
              size="small"
              onClick={() => this.setState({ notificationsAnchor: null })}
              style={{ textTransform: 'none', color: '#6b7280', fontSize: 13 }}
            >
              Fechar
            </Button>
          </Box>
        </Menu>

        {/* Filter Menu */}
        <Menu
          anchorEl={filterMenuAnchor}
          open={Boolean(filterMenuAnchor)}
          onClose={() => this.setState({ filterMenuAnchor: null })}
          PaperProps={{
            style: {
              background: themeStyles.cardBg,
              color: themeStyles.text,
              borderRadius: '12px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              overflow: 'hidden',
            }
          }}
        >
          <Box className={classes.filterMenuContent}>
            {/* Header */}
            <Box className={classes.filterMenuHeader}>
              <Box className={classes.filterMenuHeaderTitle}>
                <Box style={{ width: 32, height: 32, borderRadius: '8px', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#8BC34A">
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
                  </svg>
                </Box>
                <span>Filtros Avançados</span>
                {activeFilterCount > 0 && (
                  <Box className={classes.filterMenuBadge}>
                    {activeFilterCount} {activeFilterCount === 1 ? 'ativo' : 'ativos'}
                  </Box>
                )}
              </Box>
              {hasActiveFilters && (
                <Button
                  size="small"
                  onClick={this.clearAdvancedFilters}
                  style={{ textTransform: 'none', color: '#ef4444', fontWeight: 600, fontSize: 12 }}
                >
                  Limpar tudo
                </Button>
              )}
            </Box>

            {/* Body */}
            <Box className={classes.filterMenuBody}>
              {/* Urgência */}
              <Box className={classes.filterMenuSection}>
                <Box className={classes.filterMenuSectionHeader}>
                  <SpeedIcon style={{ fontSize: 16, color: '#f59e0b' }} />
                  <Typography className={classes.filterMenuLabel}>Urgência</Typography>
                </Box>
                <Box className={classes.filterMenuChips}>
                  {[
                    { key: 'critical', label: 'Crítico', color: '#ef4444' },
                    { key: 'warning', label: 'Atenção', color: '#f59e0b' },
                    { key: 'normal', label: 'Normal', color: '#22c55e' },
                    { key: 'waiting', label: 'Aguardando', color: '#64748b' },
                  ].map(urgency => (
                    <Chip
                      key={urgency.key}
                      size="small"
                      label={urgency.label}
                      onClick={() => this.handleFilterChange('urgencyGroup', advancedFilters.urgencyGroup === urgency.key ? null : urgency.key)}
                      className={`${classes.filterChip} ${advancedFilters.urgencyGroup === urgency.key ? classes.filterChipActive : ''}`}
                      style={{
                        borderLeft: advancedFilters.urgencyGroup !== urgency.key ? `3px solid ${urgency.color}` : undefined,
                      }}
                    />
                  ))}
                </Box>
              </Box>

              {/* Prioridades */}
              {filterOptions?.priorities?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <FiberManualRecordIcon style={{ fontSize: 16, color: '#8b5cf6' }} />
                    <Typography className={classes.filterMenuLabel}>Prioridade</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips}>
                    {filterOptions.priorities.map(priority => (
                      <Chip
                        key={priority.id}
                        size="small"
                        label={`${priority.name} (${priority.count})`}
                        onClick={() => this.handleFilterChange('priorityId', advancedFilters.priorityId === priority.id ? null : priority.id)}
                        className={`${classes.filterChip} ${advancedFilters.priorityId === priority.id ? classes.filterChipActive : ''}`}
                        style={{
                          borderLeft: priority.color && advancedFilters.priorityId !== priority.id ? `3px solid ${priority.color}` : undefined,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Canais */}
              {filterOptions?.channels?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <RouterIcon style={{ fontSize: 16, color: '#3b82f6' }} />
                    <Typography className={classes.filterMenuLabel}>Canal</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips}>
                    {filterOptions.channels.map(channel => (
                      <Chip
                        key={channel.name}
                        size="small"
                        label={`${channel.name} (${channel.count})`}
                        onClick={() => this.handleFilterChange('channelName', advancedFilters.channelName === channel.name ? null : channel.name)}
                        className={`${classes.filterChip} ${advancedFilters.channelName === channel.name ? classes.filterChipActive : ''}`}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Provedores (WhatsApp, Instagram, etc) */}
              {filterOptions?.messageproviders?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <MessageIcon style={{ fontSize: 16, color: '#10b981' }} />
                    <Typography className={classes.filterMenuLabel}>Provedor</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips}>
                    {filterOptions.messageproviders.map(provider => (
                      <Chip
                        key={provider.name}
                        size="small"
                        label={`${provider.name} (${provider.count})`}
                        onClick={() => this.handleFilterChange('messageProviderName', advancedFilters.messageProviderName === provider.name ? null : provider.name)}
                        className={`${classes.filterChip} ${advancedFilters.messageProviderName === provider.name ? classes.filterChipActive : ''}`}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Categorias */}
              {filterOptions?.categories?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <CategoryIcon style={{ fontSize: 16, color: '#f97316' }} />
                    <Typography className={classes.filterMenuLabel}>Categoria</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips} style={{ maxHeight: 100, overflowY: 'auto' }}>
                    {filterOptions.categories.map(category => (
                      <Chip
                        key={category.name}
                        size="small"
                        label={`${category.name} (${category.count})`}
                        onClick={() => this.handleFilterChange('categoryName', advancedFilters.categoryName === category.name ? null : category.name)}
                        className={`${classes.filterChip} ${advancedFilters.categoryName === category.name ? classes.filterChipActive : ''}`}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Status Chamado */}
              {filterOptions?.calledstatuses?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <AssignmentIcon style={{ fontSize: 16, color: '#8b5cf6' }} />
                    <Typography className={classes.filterMenuLabel}>Status Chamado</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips}>
                    {filterOptions.calledstatuses.map(status => (
                      <Chip
                        key={status.name}
                        size="small"
                        label={`${status.name} (${status.count})`}
                        onClick={() => this.handleFilterChange('statusName', advancedFilters.statusName === status.name ? null : status.name)}
                        className={`${classes.filterChip} ${advancedFilters.statusName === status.name ? classes.filterChipActive : ''}`}
                        style={{
                          borderLeft: status.color && advancedFilters.statusName !== status.name ? `3px solid ${status.color}` : undefined,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {/* Status Conversa */}
              {filterOptions?.chatstatuses?.length > 0 && (
                <Box className={classes.filterMenuSection}>
                  <Box className={classes.filterMenuSectionHeader}>
                    <ChatIcon style={{ fontSize: 16, color: '#3b82f6' }} />
                    <Typography className={classes.filterMenuLabel}>Status Conversa</Typography>
                  </Box>
                  <Box className={classes.filterMenuChips}>
                    {filterOptions.chatstatuses.map(status => (
                      <Chip
                        key={status.name}
                        size="small"
                        label={`${status.name} (${status.count})`}
                        onClick={() => this.handleFilterChange('statusName', advancedFilters.statusName === status.name ? null : status.name)}
                        className={`${classes.filterChip} ${advancedFilters.statusName === status.name ? classes.filterChipActive : ''}`}
                        style={{
                          borderLeft: status.color && advancedFilters.statusName !== status.name ? `3px solid ${status.color}` : undefined,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>

            {/* Footer */}
            <Box className={classes.filterMenuFooter}>
              <button
                onClick={() => this.setState({ filterMenuAnchor: null })}
                style={{
                  backgroundColor: '#8BC34A',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 24px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  width: '100%',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#689F38';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#8BC34A';
                }}
              >
                Aplicar Filtros
              </button>
            </Box>
          </Box>
        </Menu>

        <CustomizedSnackbars
          variant={this.state.notificationVariant}
          message={this.state.notificationMessage}
          isOpen={this.state.openNotification}
          toClose={() => this.setState({ openNotification: false })}
        />

        {/* VOIP — modal de confirmação do atalho de ligação (a origem real é o softphone global via voip:dial). */}
        <VoipDialConfirm
          open={this.state.dialConfirm.open}
          number={this.state.dialConfirm.number}
          providerName={this.state.dialConfirm.providerName}
          onConfirm={this.confirmDial}
          onClose={this.closeDialConfirm}
        />

        {/* Modal de Detalhes (Chamado ou Chat) */}
        <RequesterHistoryDetailsModal
          open={this.state.detailsModalOpen}
          onClose={this.closeDetailsModal}
          item={this.state.selectedItemForDetails}
          intl={this.props.intl}
          setMessage={(isOpen, variant, message) => {
            if (isOpen) this.showNotification(variant, message);
          }}
        />

        {/* Modal de Tratamento Rápido */}
        <TreatCalledModal
          open={this.state.treatCalledModalOpen}
          onClose={this.closeTreatCalledModal}
          onShowNotification={this.showNotification}
          onCalledClosed={this.removeCalledFromList}
          skipAssignment={true}
        />

        {/* Modal de Omnichannel (Chat) */}
        <OmnichannelModal
          open={this.state.omnichannelModalOpen}
          onClose={this.closeOmnichannelModal}
          chatItem={this.state.selectedChatItem}
          onChatClosed={this.handleChatClosed}
        />

        {/* Modal de Iniciar uma Pausa */}
        <BreakReasonStartDialog
          open={this.state.breakReasonStartOpen}
          handleOpenOrClose={this.closeBreakReasonStartDialog}
          classes={classes}
          setState={this.handleSetStateBreakReasonStartDialog.bind(this)}
          loading={this.state.loading || this.state.loadingHelper}
          isFinishingBreak={!!breakworks?.breakreasonactive?.id}
          onAfter={() => {
            this.setState({
              agentStatus: this.state.selectedNewStatusForBreak,
              selectedNewStatusForBreak: null
            });
          }}
        />
      </Base>
    );
  }
}

AgentWorkspace.propTypes = {
  classes: PropTypes.object.isRequired,
  agentWorkspaceHub: PropTypes.object, // Injetado pelo HOC
};

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  calleds: state.calleds,
  breakworks: state.breakworks,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch);

// HOC para injetar o contexto SignalR em um class component
function withAgentWorkspaceHub(WrappedComponent) {
  return function AgentWorkspaceHubWrapper(props) {
    const hubContext = useAgentWorkspaceHubContext();
    return <WrappedComponent {...props} agentWorkspaceHub={hubContext} />;
  };
}

// Aplicar HOCs na ordem correta
const StyledComponent = withStyles(styles)(AgentWorkspace);
const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(StyledComponent);
const RouterComponent = withRouter(ConnectedComponent);
const IntlComponent = injectIntl(RouterComponent);
const HubComponent = withAgentWorkspaceHub(IntlComponent);

export default HubComponent;
AgentWorkspace.contextType = AbilityContext;
